import {
  actionChannel,
  call,
  cancelled,
  delay,
  put,
  race,
  select,
  take,
  takeEvery,
  takeLatest,
  takeLeading,
} from 'redux-saga/effects'
import { get, map, isEmpty, isString, isPlainObject, isNil, cloneDeep } from 'lodash'
import { toast } from 'react-toastify'

import { APPLICATION_STRINGS } from '../strings'

import moment from 'moment'

import {
  createOfflineOrderSucceeded,
  createOfflineOrderFailed,
  REPLAY_AUTH_REQUESTED,
  replayAuthRequestSucceeded,
  replayAuthRequestFailed,
  saveOrder,
  saveOfflineOrder,
  START_A_TAB,
  START_OFFLINE_CARD_ORDER,
  START_ONLINE_CARD_ORDER,
  SYNC_ORDER_REQUESTED,
  syncOrderInitiated,
  syncOrderRequested,
  syncOrderSucceeded,
  syncOrderFailed,
  SYNC_OFFLINE_ORDER_REQUESTED,
  syncOfflineOrderRequested,
  updateOrderSucceeded,
  updateOrderFailed,
  UPDATE_CARD_READER_DATA,
  CLOSE_NO_OP_TENDER,
  SEND_ORDER_EMAIL,
  SEND_ORDER_TEXT,
  SYNC_ORDERS_REQUESTED,
  SYNC_REPLAY_AUTH_ORDERS_REQUESTED,
  replayAuthRequested,
  updateOrderInProgress,
  ADD_PAYMENT_TO_ORDER_IN_PROGRESS,
  loadTabOrdersSucceeded,
  loadTabOrdersFailed,
  TAB_ORDERS_REQUESTED,
  ORDER_DETAILS_REQUESTED,
  loadOrderDetailsSucceeded,
  loadOrderDetailsFailed,
  orderDetailsRequested,
  CLOSE_TAB_ORDER,
  ADD_ITEMS_TO_TAB,
  ADD_ITEMS_TO_TAB_OFFLINE,
  ADD_DISCOUNTS_TO_TAB_ORDER,
  DELETE_DISCOUNTS_FROM_TAB_ORDER,
  addItemsToOrder,
  addItemsToTabFailed,
  addItemsToTabSucceeded,
  clearOrderInProgress,
  SYNC_AND_SAVE_ORDER_IN_PROGRESS,
  setQRPayAuthError,
  duplicateOrderWithNewIds,
  setOrderInProgressWithId,
  restoreQRPaymentandAuthorizationFailedStatus,
  CLOSE_PRE_AUTHED_RC_ORDER,
  ADD_NEW_PAYMENTS,
  REMOVE_PAYMENT,
  UPDATE_SAVED_PAYMENT,
  closeTabOrder,
  CANCEL_REMOVE_PAYMENT,
  CANCEL_ORDER,
  SYNC_NEXT_ORDER_TO_PLATFORM,
  setCurrentOrderId,
} from '../actions/order'

import { SAVE_RICH_CHECKOUT_ORDER_REQUESTED, saveRichCheckoutOrder } from '../actions/richCheckout/order'
import { clearRemoteOrderTotal } from '../actions/orderTotalRemote'
import { clearCart } from '../actions/cart'
import { setDataIsUploading, setSafStatusProgress, setSafStatusRequesting } from '../VNSyncManager/ActionCreators'
import { addPromotionsToOrder, clearPromotionsOnOrder } from '../actions/promotion'
import { setUpdatedSince } from '../actions/order'

import MutationApi from '../remote/mutationApi'
import StadiumRemote from '../remote/stadiumRemote'

import { getItemsForCurrentMenu, getMenuServiceCharge } from '../selectors/items'
import { getDataIsUploading, getIsSyncing, getSafStatusRequesting } from '../VNSyncManager/Selectors'
import { getCartItems, getTaxRate, getTaxByItem, getCartNotes, getOrderNotes, getTaxExemptData } from '../selectors/cart'
import {
  makeGetOrder,
  getOfflineLocalIds,
  getSyncableOfflineLocalIds,
  getOrderIdsToStateSync,
  getOrderInProgress,
  getUpdatedSince,
  getQRPayAuthError,
  getUserUuidFromOrderInProgress,
} from '../selectors/order'
import {
  getIsKiosk,
  getCurrentMenu,
  getKitchenPrintingEnabled,
  getUseNormalTaxRounding,
  getUseTaxClasses,
} from '../selectors/menus'
import { getBackbarMode, getDeviceSubtype, getNetworkAvailable } from '../selectors/config'
import { getActiveAttendantId, getAttendants } from '../selectors/attendant'
import { getOrderSubumissionUuid, getRemoteOrderTotal } from '../selectors/orderTotalRemote'
import { getSelectedPromotions } from '../selectors/promotion'

import { customHistory } from '../stores'

import { incrementNextOrderNumber, nextPosOrderNumber } from '../utils/orderNumbers'
import {
  calculateTax,
  calculateSubtotal,
  calculateServiceCharge,
  calculateIndividualTaxAmount,
  calculateServiceFeeTaxRules,
} from '../utils/totalUtils'
import { getNetworkAvailableValue } from '../utils/networkConnected'
import createDataDogLog from '../utils/datadog'
import DataMapper from '../utils/dataMapper'
import PeripheralBridge from '../utils/peripheralBridge'
import {
  approvedOfflineThenDeclined,
  isOfflineApproval,
  responseStatusString,
  statusCheckComplete,
  approvedOfflineNoResponse,
} from '../utils/offlineReplayStatuses'
import {
  STADIUM_ORDER_STATES,
  INTERNAL_ORDER_STATES,
  isFinalState,
  isTabbed,
  isQRPay,
  isCreditType,
  isScannedTenderNonCC,
  isRichCheckout,
  hasCreditType,
} from '../utils/orderStates'
import {
  isCardPresentCardType,
  isSamePayment,
  mapUpdatedPaymentUuidFromResponse,
  orderIsScannedTender,
  PAYMENT_TYPES,
  PAYMENT_TYPES_INTERNAL,
} from '../utils/paymentTypes'
import {
  getIsPreAuthTab,
  makeCreateOrderLineItems,
  makeLineItemData,
  createOrderParams,
  orderReplayRequestId,
  mapCardReaderDataForSubmittedOrder,
  hasOfflineCardTransactions,
  distributeTipAmount,
  ensureRelatedInvoiceNumbers,
} from '../utils/orderUtils'
import DeviceSubtypes from '../utils/deviceSubtypes'
import { ToastManager } from '../utils/toastManager'
import { orderUuidFromOrderNumber } from '../utils/orderNumbers'

import { getDeviceMode } from '../VNMode/Selectors'
import { MODES } from '../VNMode/Reducer'
import { getCurrentPaymentFlow } from '../VNCustomerFacingDisplay/Selectors'
import { CFD_POS_PAYMENT_FLOWS } from '../VNCustomerFacingDisplay/Enums'
import { paymentTypeIsPpi } from '../VNPPI/Utils'
import { setOrderPayments, setPreOrderPayments } from '../VNPPI/ActionCreators'
import { SetOfflineDialog } from '../VNDialogs/ActionCreators'
import { bridge_sendPrintStatus, resetCFDrequest } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { createOrder } from '@ordernext/networking-stadium/stadium/actions'
import { printOrder } from '../actions/printer'
import { PRINT_TYPES } from '../utils/printing'
import { setRouteAction } from '../VNRoutes/Actions'

import { executePerformMaintenance } from '../utils/bridgeMethods'
import { enableClearSafDeclines } from '../utils/buildSettings'
import { isSDKCompatible } from '../VNAndroidSDK/Utils'
import { getAndroidSDKVersion } from '../VNAndroidSDK/Selectors'
import { getUsbPrintingEnabled } from '../selectors/printer'
import { refundReceiptsEnabled } from '../utils/featureFlags'
import { centsToDollars } from '../utils/formatters'
import { setReopenedTabPaymentsAction } from '../VNTenders/ActionCreators'
import { mapPayments } from '../models/Order'
import { stopSpinner } from '../VNLoader/ActionCreators'
import { getIsOrderTaxExempt, getTaxClasses, getTaxExemptApproverUuid, getTaxRules } from '../VNTaxes/Selectors'

import { setShouldStopSync } from '../VNSyncManager/ActionCreators'
import { getReopenedTabPayments } from '../VNTenders/Selectors'
import { resetCFD, setCalculatedCurrentCartValues } from '../VNCustomerFacingDisplay/ActionCreators'

import { isFeatureOn } from '../VNConfigurations/Selectors'
import { VNCONFIGS_FEATURE_ENABLEMENT_KEYS } from '../VNConfigurations/Enums'
import { getKioskOfflineEnabled } from '../kiosk/utils/config'
import { getDeviceSerial } from '../utils/deviceData'
import { isNetworkError, isPrintError } from '../VNUtil/Errors'
import { setNetworkAvailable } from '../actions/config'

// Gateway timeouts from platform show ~30s in DataDog
// FCC default timeout is 35s, PAX is 60s, split the difference to 45
const MS_GATEWAY_FORCE_CONTINUE = 45_000
const STADIUM_CREATE_ENDPOINT = '/pos/orders'
const PRINTER_NOT_CONFIGURED_MESSAGE = 'Printers are not configured for order'

const generateUuid = require('uuid/v4')
const getOrder = makeGetOrder()
const getCreateOrderParams = (order) => createOrderParams(order)

function presentOrderToast(kitchenPrintingEnabled, response) {
  const errorMessage = response?.data?.errorMessage
  const friendlyMessage = response?.data?.friendlyMessage

  if (response?.config?.method !== 'post') return response
  if (response?.config?.url !== STADIUM_CREATE_ENDPOINT) return response

  // If this is a create request, toast the user appropriately with the response.
  if (errorMessage) {
    ToastManager.error(`${errorMessage}`, { autoClose: false })
  } else if (friendlyMessage) {
    if (friendlyMessage.includes(PRINTER_NOT_CONFIGURED_MESSAGE)) {
      ToastManager.error(`${friendlyMessage}`, { autoClose: false })
      return
    }
    ToastManager.success(`${friendlyMessage}`, { autoClose: true })
  } else if (kitchenPrintingEnabled) {
    ToastManager.success('Success. Order placed and kitchen chits printed.', { autoClose: true })
  }
}

function* verifyCurrentAttendant(isKiosk) {
  const attendantsExist = !isEmpty(yield select(getAttendants))

  if (!attendantsExist || isKiosk) {
    return null
  }

  const employeeId = yield select(getActiveAttendantId)

  if (employeeId) {
    return employeeId
  }

  yield call(directTo, 'push', '/user-login')
  ToastManager.error(APPLICATION_STRINGS.PLEASE_LOGIN, { autoClose: false })
  createDataDogLog('error', APPLICATION_STRINGS.PLEASE_LOGIN)
  return undefined
}

// TODO(mkramerl): This is disgusting. I'm so angry right now.
const makeCreateOrderParams = ({
  amountInCents,
  tipAmountInCents,
  signature,
  itemModels,
  menuUuid,
  tenderAmountInCents,
  orderNumber,
  invoiceNumber,
  currentOrderState,
  paymentType,
  submittedAt,
  uuid,
  orderState,
  employeeId,
  affiliations,
  promotions,
  userNotes,
  payments,
  shortDescription,
  originalClientCreatedAt,
}) => {
  let shape = {
    clientCreatedAt: originalClientCreatedAt || moment(submittedAt).toISOString(),
    standMenuUuid: menuUuid,
    orderMenuItems: makeCreateOrderLineItems(itemModels),
    orderNumber,
    payments: [
      {
        paymentType,
        amountInCents: tenderAmountInCents ?? amountInCents,
        shortDescription,
        tip: tipAmountInCents !== undefined ? tipAmountInCents : undefined,
        userAttributes: invoiceNumber ? { href: invoiceNumber, freedompayInvoiceNumber: invoiceNumber } : undefined,
      },
    ],
    webOrder: true,
    uuid,
    affiliations,
    promotions,
    tipAmountInCents,
    userNotes,
  }

  if (payments) {
    shape.payments = payments
  }

  if (signature) {
    shape.receiptSignature = signature
  }

  if (employeeId) {
    shape.employeeId = employeeId
  }

  // TODO(mkramerl): Utilize our actual platform order states across the entire POS rather than
  // 'open', 'closed', 'failed'.

  if (orderState === INTERNAL_ORDER_STATES.FAILED) {
    shape.state = STADIUM_ORDER_STATES.AUTHORIZATION_FAILED
  } else if (orderState === INTERNAL_ORDER_STATES.PREAUTH) {
    shape.state = STADIUM_ORDER_STATES.SUBMITTED
  } else if (orderState === INTERNAL_ORDER_STATES.CANCELLED) {
    shape.state = STADIUM_ORDER_STATES.CANCELLED
  }

  return shape
}

const getUserNameFromCard = (cardReaderData) => {
  // example: "OBERG/PETER               "
  // super defensive with the string methods below because I don't know much about different possibilities
  const name = cardReaderData.cardholderName || '/'
  const split = name.split('/')
  const firstName = (split[1] || '').trim()
  const lastName = (split[0] || '').trim()

  return `${firstName} ${lastName}`
}

// called user_attributes in stadium, but it mostly contains credit card attributes
const makeUserAttributes = (cardReaderData, internalPaymentType = null) => {
  const { authResponseData, receiptData } = cardReaderData

  const { authorizationCode, processorTransactionId, reconciliationId } = authResponseData || {}
  const { approvalCode, authStatus, maskedCardNumber, maskedPan } = receiptData || {}

  const safeFour = maskedCardNumber || ''
  const lastFour = safeFour?.substring?.(safeFour?.length - 4) || ''

  const token = cardReaderData?.tokenInformation?.token
  const deviceId = getDeviceSerial()
  const isOfflineApproval = cardReaderData?.isOfflineApproval

  return {
    last_4: lastFour,

    // needed in this format for refunds
    freedompayRequestId: cardReaderData.requestId,
    freedompayMerchantReferenceCode: cardReaderData.merchantReferenceCode || cardReaderData.uuid,
    freedompayInvoiceNumber: cardReaderData.invoiceNumber,
    freedompayIssuerName: cardReaderData.cardIssuer || cardReaderData.cardType,
    freedompayStoreId: cardReaderData.storeId,
    freedompayTerminalId: cardReaderData.terminalId,

    isCardPresentTransaction: isCardPresentCardType(cardReaderData.cardType),

    // extra data to help troubleshoot customer charge back requests
    authorizationCode,
    processorTransactionId,
    reconciliationId,
    approvalCode,
    authStatus,
    maskedCardNumber,
    maskedPan,
    token,
    deviceId,
    isOfflineApproval,
    internalPaymentType,
    transType: cardReaderData.transType,
    cardholderName: cardReaderData.cardholderName,
  }
}

export function* closeNoOpTenderSaga(params = {}) {
  const deviceSubtype = yield select(getDeviceSubtype)
  const isKiosk = DeviceSubtypes.isKiosk(deviceSubtype)
  const employeeId = yield verifyCurrentAttendant(isKiosk)
  const redirectOnSync = params?.payload?.redirectOnSync ?? false
  const cashRoundingInCents = params?.payload?.cashRoundingInCents ?? 0
  if (employeeId === undefined) return

  const tender = params?.payload?.tender ?? { name: 'cash', displayName: 'Cash' }
  const tipAmountInCents = parseInt(params?.payload?.tipAmountInCents ?? 0)
  const charityAmountInCents = parseInt(params?.payload?.charityAmountInCents ?? 0)
  const submittedAt = new Date()
  const useNormalTaxRounding = yield select(getUseNormalTaxRounding)
  const taxClasses = yield select(getTaxClasses)
  const taxRules = yield select(getTaxRules)
  const useTaxClasses = yield select(getUseTaxClasses)
  const taxExempt = yield select(getIsOrderTaxExempt)
  const taxExemptData = yield select(getTaxExemptData)
  const taxExemptReason = taxExemptData?.reason || ''
  const taxExemptApproverUuid = yield select(getTaxExemptApproverUuid)

  const paymentCompleted = true

  const { menuUuid, revenueCenterUuid, revenueName } = yield menuAndRvcUuids(isKiosk)

  const lineItems = yield select(getCartItems)
  let userNotes = yield select(getCartNotes)
  const orderNotes = yield select(getOrderNotes)

  if (orderNotes) {
    userNotes = userNotes ? `${userNotes?.split('\nNote:')[0]}\n${orderNotes}` : `\n${orderNotes}`
  }

  const uuid = yield select((state) => getOrderSubumissionUuid(state, params.payload?.orderUuid))

  // Perhaps this is another attempt to trigger the creation of an order already in our DB.
  const order = yield select(getOrder, uuid)

  const orderNumber = createOrder(order)?.orderNumber ?? params?.payload?.orderNumber ?? nextPosOrderNumber()
  const itemModels = order?.itemModels ?? makeLineItemData(lineItems)

  const taxRate = yield select(getTaxRate)
  const taxByItem = yield select(getTaxByItem)

  const remoteOrderTotal = yield select(getRemoteOrderTotal)
  let discountAmountInCents = remoteOrderTotal?.discountAmountInCents ?? 0

  if (params?.payload?.discountAmountInCents) {
    discountAmountInCents = params.payload.discountAmountInCents
  }

  const affiliations = remoteOrderTotal?.isAvailable ? [] : null

  let taxAmountInCents
  let calculateTaxResult
  let taxRulesBreakdown = {}

  if (params?.payload?.hasOwnProperty('taxAmountInCents')) {
    taxAmountInCents = params?.payload?.taxAmountInCents
  } else if (remoteOrderTotal?.isAvailable) {
    taxAmountInCents = remoteOrderTotal?.taxAmountInCents ?? 0
    taxRulesBreakdown = remoteOrderTotal?.taxRulesBreakdown ?? {}
  } else {
    calculateTaxResult = calculateTax(
      lineItems,
      taxRate,
      taxByItem,
      useNormalTaxRounding,
      useTaxClasses,
      taxClasses,
      taxRules,
      taxExempt,
    )
    taxAmountInCents = calculateTaxResult.taxAmountInCents
    taxRulesBreakdown = calculateTaxResult.taxRulesBreakdown ?? {}
  }

  let subtotalAmountInCents = remoteOrderTotal?.subtotalInCents ?? calculateSubtotal(lineItems)
  let amountInCents =
    (remoteOrderTotal?.totalAmountInCents ?? subtotalAmountInCents + taxAmountInCents) + tipAmountInCents + charityAmountInCents
  let serviceFee = { name: 'Service Charge', total: 0, legal: null }

  if (params?.payload?.serviceFee) {
    serviceFee = {
      name: remoteOrderTotal?.serviceChargeName,
      total: params?.payload?.serviceFee?.total ?? 0,
      legal: remoteOrderTotal.serviceChargeLegal,
    }

    taxAmountInCents += calculateIndividualTaxAmount(taxRate, serviceFee.total, true, useNormalTaxRounding)
    amountInCents = amountInCents + serviceFee.total
  } else if (!isNil(remoteOrderTotal?.totalAmountInCents)) {
    // Recalibrate the subtotal and total based on whether or not there is a remote total.
    // When there is a remote total, the subtotal is present and properly calculated.
    serviceFee = {
      name: remoteOrderTotal?.serviceChargeName,
      total: remoteOrderTotal?.serviceChargeInCents ?? 0,
      legal: remoteOrderTotal.serviceChargeLegal,
    }
  } else {
    // When there is no remote total, the service fee needs to be calculated and added into the
    // total but not the subtotal.
    const serviceCharge = yield select((state) => getMenuServiceCharge(state))
    serviceFee = {
      name: serviceCharge.name,
      total: calculateServiceCharge(serviceCharge, subtotalAmountInCents) ?? 0,
      legal: serviceCharge.legal,
      taxClassUuid: serviceCharge?.taxClassUuid,
    }

    let serviceFeeTaxAmountInCents = 0

    if (useTaxClasses) {
      const calculateServiceFeeTaxRulesResult = calculateServiceFeeTaxRules(
        taxRulesBreakdown,
        serviceFee,
        useNormalTaxRounding,
        taxClasses,
        taxRules,
        taxExempt,
      )
      serviceFeeTaxAmountInCents = calculateServiceFeeTaxRulesResult.serviceFeeTaxAmountInCents
      taxRulesBreakdown = calculateServiceFeeTaxRulesResult.taxRulesBreakdown || {}
    } else {
      serviceFeeTaxAmountInCents = calculateIndividualTaxAmount(
        taxRate,
        serviceFee.total,
        serviceCharge.taxable,
        useNormalTaxRounding,
      )
    }

    taxAmountInCents += serviceFeeTaxAmountInCents
    amountInCents = amountInCents + serviceFee.total + serviceFeeTaxAmountInCents
  }

  if (isEmpty(lineItems) && isEmpty(itemModels) && !isKiosk) {
    yield call(directTo, 'push', '/concession-order')
    createDataDogLog('error', APPLICATION_STRINGS.ORDER_ONE_ITEM)
    return
  }

  let promotions = yield select(getSelectedPromotions)
  if (isEmpty(promotions) || !remoteOrderTotal.isAvailable) {
    promotions = undefined
  }

  const roundedAmountInCents =
    (params?.payload?.hasOwnProperty('amountInCents') ? params.payload.amountInCents : amountInCents) + cashRoundingInCents

  const createOrderParams = makeCreateOrderParams({
    amountInCents: roundedAmountInCents,
    itemModels,
    menuUuid,
    orderNumber: getCreateOrderParams(order)?.orderNumber ?? orderNumber,
    paymentType: tender.name,
    submittedAt,
    orderState: INTERNAL_ORDER_STATES.CLOSED,
    uuid,
    employeeId,
    affiliations,
    promotions,
    tipAmountInCents,
    charityAmountInCents,
    userNotes,
    payments: params?.payload?.hasOwnProperty('payments') ? params.payload.payments : null,
    shortDescription: tender.displayName,
    originalClientCreatedAt: getCreateOrderParams(order)?.clientCreatedAt,
  })

  const orderData = {
    ...createOrderParams,
    amountInCents: roundedAmountInCents,
    displayName: tender.displayName,
    subtotalAmountInCents: params?.payload?.hasOwnProperty('subtotalAmountInCents')
      ? params.payload.subtotalAmountInCents
      : subtotalAmountInCents,
    taxAmountInCents,
    discountAmountInCents,
    tipAmountInCents,
    charityAmountInCents,
    balanceDueInCents: 0,
    serviceFee,
    itemModels,
    paymentCompleted,
    orderNumber,
    submittedAt,
    orderState: 'closed',
    uuid,
    revenueCenterUuid,
    revenueName,
    userNotes,
    taxRulesBreakdown,
    taxExempt,
    taxExemptReason,
    taxExemptApproverUuid: taxExempt ? taxExemptApproverUuid : '',
    cashRounded: cashRoundingInCents !== 0,
    cashRoundingInCents,
  }

  yield put(saveOrder(ensureRelatedInvoiceNumbers(orderData)))
  yield put(syncOrderRequested({ orderUuid: uuid, redirect: redirectOnSync }))
  yield put(clearRemoteOrderTotal())
  yield put(clearOrderInProgress())

  if (!isKiosk && !redirectOnSync) {
    yield call(directTo, 'push', `/receipt/${uuid}`)
  }
}

function* menuAndRvcUuids(isKiosk) {
  let menuUuid = yield select((state) => get(state, 'config.configuration.menuUuids[0]', ''))
  let revenueCenterUuid = yield select((state) => get(state, 'revenueCenter.activeRevenueCenter', 'unassigned'))
  let revenueName = yield select((state) => get(state, `menus.byId.${menuUuid}.standName`, 'unassigned'))

  if (isKiosk) {
    menuUuid = yield select((state) => get(state, 'appState.currentMenuId'))
    revenueCenterUuid = yield select((state) => get(state, `menus.byId.${menuUuid}.standUuid`, 'unassigned'))
    revenueName = yield select((state) => get(state, `menus.byId.${menuUuid}.standName`, 'unassigned'))
  }

  return { menuUuid, revenueCenterUuid, revenueName }
}

export function* sendOrderText(params = {}) {
  const orderUuid = params.payload?.orderUuid
  const userPhone = params.payload?.userPhone

  try {
    yield call(StadiumRemote.updatePosOrder, orderUuid, { userPhone }, false)
    toast.success(APPLICATION_STRINGS.TEXT_SENT)
    bridge_sendPrintStatus(false, APPLICATION_STRINGS.TEXT_SENT)
  } catch (err) {
    toast.error(APPLICATION_STRINGS.TEXT_FAILED_WITH_DATA + err)
    bridge_sendPrintStatus(true, `${APPLICATION_STRINGS.TEXT_FAILED} ${err}`)
  }
  return
}

export function* watchSendOrderText() {
  yield takeEvery(SEND_ORDER_TEXT, sendOrderText)
}

export function* sendOrderEmail(params = {}) {
  const payload = params.payload

  try {
    yield call(StadiumRemote.sendEmailJobToStadium, payload)
    toast.success(APPLICATION_STRINGS.EMAIL_SENT)
  } catch (err) {
    toast.error(APPLICATION_STRINGS.EMAIL_FAILED_WITH_DATA + err)
  }
  return
}

export function* watchSendOrderEmail() {
  yield takeEvery(SEND_ORDER_EMAIL, sendOrderEmail)
}

export function* startOnlineCardOrder(params = {}) {
  const isKiosk = get(params, 'payload.isKiosk', false)
  const employeeId = yield verifyCurrentAttendant(isKiosk)
  if (employeeId === undefined) return
  const orderInProgress = yield select(getOrderInProgress)
  const useNormalTaxRounding = yield select(getUseNormalTaxRounding)
  const taxClasses = yield select(getTaxClasses)
  const taxRules = yield select(getTaxRules)
  const useTaxClasses = yield select(getUseTaxClasses)
  const taxExempt = yield select(getIsOrderTaxExempt)
  const taxExemptData = yield select(getTaxExemptData)
  const taxExemptReason = taxExemptData?.reason || ''
  const taxExemptApproverUuid = yield select(getTaxExemptApproverUuid)
  const invoiceNumber = params?.payload?.invoiceNumber || params?.payload?.cardReaderData?.invoiceNumber || null

  const tenderAmountInCents = params?.payload?.tenderAmountInCents

  const cardReaderData = params?.payload?.cardReaderData ?? {}
  const signature = params?.payload?.signature

  // TODO We should make a separate saga for handling preAuth and failed split orders that send a more accurate representation of the order.
  // orderInProgress data used only for preauth order submission accuracy
  const tipAmountInCents = parseInt(orderInProgress?.tipAmountInCents ?? params?.payload?.tipAmountInCents ?? 0)
  const charityAmountInCents = parseInt(orderInProgress?.charityAmountInCents ?? params?.payload?.charityAmountInCents ?? 0)
  const affiliations = orderInProgress?.affiliations ?? []

  const submittedAt = new Date()
  const paymentCompleted = cardReaderData.transType === 'sale'
  const isTab = false
  const orderState = get(params, 'payload.orderState', INTERNAL_ORDER_STATES.CLOSED)

  const { menuUuid, revenueCenterUuid, revenueName } = yield menuAndRvcUuids(isKiosk)
  const menu = yield select((state) => getCurrentMenu(state))
  const menuSubtype = get(menu, 'subtype')
  const uuid = yield select((state) => getOrderSubumissionUuid(state, cardReaderData?.uuid))
  const order = yield select(getOrder, uuid)

  // for kiosk orders, we're passing in line items to avoid race condition of cart being cleared
  // when redirecting to the attract loop
  let lineItems = get(params, 'payload.lineItems')
  if (!lineItems) lineItems = yield select(getCartItems)

  let userNotes = get(params, 'payload.userNotes')
  const orderNotes = yield select(getOrderNotes)

  if (!userNotes) userNotes = yield select(getCartNotes)

  if (orderNotes) {
    userNotes = userNotes ? `${userNotes?.split('\nNote:')[0]}\n${orderNotes}` : `\n${orderNotes}`
  }

  if (isEmpty(lineItems) && !isKiosk && !isTabbed(order) && !order.previousAuthorizationFailedStatus) {
    yield put(setRouteAction('/concession-order'))
    createDataDogLog('error', `Issue Creating Orders ${uuid} - ${APPLICATION_STRINGS.ORDER_ONE_ITEM}`)
    ToastManager.error(APPLICATION_STRINGS.ORDER_ONE_ITEM)
    return
  }

  // Perhaps this is another attempt to trigger the creation of an order already in our DB.

  // To ensure using the correct order number, the hiarchy system goes as follows
  // 1. if the order has been previously submitted to the platform, use the order number on the submitted order
  // 2. if there is a current order in progress, use that order number
  // 3. otherwise, use the order number attached to the card reader response or passed in through the dispatch
  const orderNumber =
    getCreateOrderParams(order)?.orderNumber ??
    orderInProgress?.orderNumber ??
    cardReaderData?.orderNumber ??
    params?.payload?.orderNumber

  // fetches items from order in progress or latest from request or cart
  const itemModels = orderInProgress?.itemModels ?? (!isEmpty(lineItems) ? makeLineItemData(lineItems) : order?.itemModels)

  // previous order state was cancelled and it's now a new preauth order
  const currentItems =
    params?.payload?.orderState === 'preauth' && order?.state === 'cancelled' ? makeLineItemData(lineItems) : itemModels

  const taxRate = yield select(getTaxRate)
  const taxByItem = yield select(getTaxByItem)
  const remoteOrderTotal = yield select(getRemoteOrderTotal)
  const discountAmountInCents = remoteOrderTotal?.discountAmountInCents ?? 0

  let taxAmountInCents
  let calculateTaxResult
  let taxRulesBreakdown = {}

  if (remoteOrderTotal?.isAvailable) {
    taxAmountInCents = remoteOrderTotal?.taxAmountInCents ?? 0
    taxRulesBreakdown = remoteOrderTotal?.taxRulesBreakdown || {}
  } else {
    calculateTaxResult = calculateTax(
      lineItems,
      taxRate,
      taxByItem,
      useNormalTaxRounding,
      useTaxClasses,
      taxClasses,
      taxRules,
      taxExempt,
    )
    taxAmountInCents = calculateTaxResult.taxAmountInCents
    taxRulesBreakdown = calculateTaxResult.taxRulesBreakdown || {}
  }

  let subtotalAmountInCents = remoteOrderTotal?.subtotalInCents ?? calculateSubtotal(lineItems)
  let amountInCents =
    (remoteOrderTotal?.totalAmountInCents ?? subtotalAmountInCents + parseInt(taxAmountInCents)) +
    parseInt(tipAmountInCents) +
    parseInt(charityAmountInCents)
  let serviceFee = { name: 'Service Charge', total: 0, legal: null }

  // Recalibrate the subtotal and total based on whether or not there is a remote total.
  if (!isNil(remoteOrderTotal?.totalAmountInCents)) {
    // When there is a remote total, the subtotal is present and properly calculated.
    serviceFee = {
      name: remoteOrderTotal?.serviceChargeName,
      total: remoteOrderTotal?.serviceChargeInCents ?? 0,
      legal: remoteOrderTotal.serviceChargeLegal,
    }
  } else {
    // When there is no remote total, the service fee needs to be calculated and added into the
    // total but not the subtotal.
    const serviceCharge = yield select((state) => getMenuServiceCharge(state))
    serviceFee = {
      name: serviceCharge.name,
      total: calculateServiceCharge(serviceCharge, subtotalAmountInCents) ?? 0,
      legal: serviceCharge.legal,
      taxClassUuid: serviceCharge?.taxClassUuid,
    }

    let serviceFeeTaxAmountInCents = 0

    if (useTaxClasses) {
      const calculateServiceFeeTaxRulesResult = calculateServiceFeeTaxRules(
        taxRulesBreakdown,
        serviceFee,
        useNormalTaxRounding,
        taxClasses,
        taxRules,
        taxExempt,
      )
      serviceFeeTaxAmountInCents = calculateServiceFeeTaxRulesResult.serviceFeeTaxAmountInCents
      taxRulesBreakdown = calculateServiceFeeTaxRulesResult.taxRulesBreakdown || {}
    } else {
      serviceFeeTaxAmountInCents = calculateIndividualTaxAmount(
        taxRate,
        serviceFee.total,
        serviceCharge.taxable,
        useNormalTaxRounding,
      )
    }

    taxAmountInCents += serviceFeeTaxAmountInCents
    amountInCents = amountInCents + serviceFee.total + serviceFeeTaxAmountInCents
  }

  const userAttributes = makeUserAttributes(cardReaderData)
  if (invoiceNumber && !userAttributes.freedompayInvoiceNumber) {
    userAttributes.freedompayInvoiceNumber = invoiceNumber
  }

  let promotions = yield select(getSelectedPromotions)
  if (isEmpty(promotions) || !remoteOrderTotal.isAvailable) {
    promotions = undefined
  }

  const shortDescription = userAttributes?.freedompayIssuerName
    ? `${userAttributes?.freedompayIssuerName} ${userAttributes?.last_4}`
    : undefined

  const balanceDueInCents = orderInProgress?.balanceDueInCents ?? 0

  const createOrderParams = {
    ...makeCreateOrderParams({
      amountInCents,
      tenderAmountInCents,
      tipAmountInCents,
      charityAmountInCents,
      signature,
      employeeId,
      itemModels: currentItems,
      menuUuid,
      orderNumber: getCreateOrderParams(order)?.orderNumber ?? orderNumber,
      currentOrderState: getCreateOrderParams(order)?.state,
      paymentType: 'freedompay_credit',
      submittedAt,
      isTab,
      orderState,
      uuid,
      affiliations,
      promotions,
      invoiceNumber,
      userNotes,
      shortDescription,
      originalClientCreatedAt: getCreateOrderParams(order)?.clientCreatedAt,
    }),
    userAttributes: userAttributes,
    userName: getUserNameFromCard(cardReaderData),
    reason: params?.payload?.reason,
  }

  const orderData = {
    ...createOrderParams,
    amountInCents,
    tipAmountInCents,
    charityAmountInCents,
    subtotalAmountInCents,
    discountAmountInCents,
    taxAmountInCents,
    balanceDueInCents,
    serviceFee,
    cardReaderData,
    isTab,
    itemModels: currentItems,
    menuSubtype,
    orderNumber,
    orderState,
    paymentCompleted,
    revenueCenterUuid,
    revenueName,
    signature,
    submittedAt,
    uuid,
    invoiceNumber: userAttributes.freedompayInvoiceNumber,
    userNotes,
    taxRulesBreakdown,
    taxExempt,
    taxExemptReason,
    taxExemptApproverUuid: taxExempt ? taxExemptApproverUuid : '',
  }

  if (orderState === INTERNAL_ORDER_STATES.CLOSED) {
    yield put(clearRemoteOrderTotal())
  }

  // handle submitting card auth before and after BroadPOS
  const submittedStates = [INTERNAL_ORDER_STATES.PREAUTH, INTERNAL_ORDER_STATES.CANCELLED, INTERNAL_ORDER_STATES.FAILED]
  if (submittedStates.includes(orderState) && !isKiosk) {
    orderData.payments[0].amountInCents = 0
  }

  // If order has failed, balance due is reset
  if (orderState === INTERNAL_ORDER_STATES.FAILED) {
    orderData.balanceDueInCents = orderData.amountInCents
  }

  if (!orderData.state) {
    createDataDogLog('error', '[START ONLINE CARD ORDER] Order created without state', { orderData })
  }

  yield put(saveOrder(ensureRelatedInvoiceNumbers(orderData)))
  yield put(syncOrderRequested({ orderUuid: uuid }))
}

const directTo = (method = 'push', pathOrOptions) => {
  if (pathOrOptions === undefined) return

  if (isString(method) && isString(pathOrOptions)) {
    customHistory[method](pathOrOptions)
  } else if (isString(method) && isPlainObject(pathOrOptions)) {
    customHistory[method](pathOrOptions)
  }
}

export function* updateCardReaderDataSaga(params) {
  const orderId = get(params, 'payload.orderId')
  const order = yield select(getOrder, orderId)
  const newCardReaderData = get(params, 'payload.cardReaderData', {})
  const userAttributes = makeUserAttributes(newCardReaderData)
  const newCreateOrderParams = {
    ...getCreateOrderParams(order),
    userAttributes: userAttributes,
    userName: getUserNameFromCard(newCardReaderData),
    payments: [
      {
        paymentType: get(order, 'createOrderParams.payments[0]', {}).paymentType,
        amountInCents: order.amountInCents,
      },
    ],
  }

  yield put(
    saveOrder({
      uuid: order.uuid,
      cardReaderData: newCardReaderData,
      createOrderParams: newCreateOrderParams,
      paymentCompleted: true,
      invoiceNumber: userAttributes.freedompayInvoiceNumber,
    }),
  )
}

export function* startATabSaga(params = {}) {
  const isKiosk = get(params, 'payload.isKiosk', false)
  const tabName = params?.payload?.tabName ?? ''
  const printAuth = params?.payload?.printAuth
  const redirectPath = params?.payload?.redirectPath
  const employeeId = yield verifyCurrentAttendant(isKiosk)
  if (employeeId === undefined) return
  const cfdMode = yield select(getDeviceMode)

  const remoteOrderTotal = yield select(getRemoteOrderTotal)
  const useNormalTaxRounding = yield select(getUseNormalTaxRounding)
  const taxClasses = yield select(getTaxClasses)
  const taxRules = yield select(getTaxRules)
  const useTaxClasses = yield select(getUseTaxClasses)
  const taxExempt = yield select(getIsOrderTaxExempt)
  const taxExemptData = yield select(getTaxExemptData)
  const taxExemptReason = taxExemptData?.reason || ''
  const taxExemptApproverUuid = yield select(getTaxExemptApproverUuid)

  const paymentId = params?.payload?.paymentId ?? ''
  const isCardTransaction = !isEmpty(params?.payload?.cardReaderData) ? PAYMENT_TYPES.CREDIT_CARD : null
  const paymentType = params?.payload?.paymentType ?? isCardTransaction
  const shortDescription = params?.payload?.shortDescription ?? 'N/A'
  const cardReaderData = params?.payload?.cardReaderData
  const orderNumber = cardReaderData?.orderNumber ?? params?.payload?.orderNumber ?? nextPosOrderNumber()
  const uuid = orderUuidFromOrderNumber(orderNumber)
  const submittedAt = Date.now()
  const orderState = get(params, 'payload.orderState', 'tabbed')

  const { menuUuid, revenueCenterUuid, revenueName } = yield menuAndRvcUuids(isKiosk)
  const menu = yield select((state) => getCurrentMenu(state))
  const menuSubtype = get(menu, 'subtype')

  yield put(stopSpinner())

  // for kiosk orders, we're passing in line items to avoid race condition of cart being cleared
  // when redirecting to the attract loop
  let lineItems = get(params, 'payload.lineItems')
  if (!lineItems) lineItems = yield select(getCartItems)

  let userNotes = get(params, 'payload.userNotes')
  const orderNotes = yield select(getOrderNotes)

  if (!userNotes) userNotes = yield select(getCartNotes)

  if (orderNotes) {
    userNotes = userNotes ? `${userNotes?.split('\nNote:')[0]}\n${orderNotes}` : `\n${orderNotes}`
  }

  if (isEmpty(lineItems) && !isKiosk) {
    yield put(setRouteAction('/concession-order'))

    ToastManager.error(APPLICATION_STRINGS.ORDER_ONE_ITEM)

    createDataDogLog('error', APPLICATION_STRINGS.ORDER_ONE_ITEM)
    yield put(stopSpinner())
    return
  }

  // Perhaps this is another attempt to trigger the creation of an order already in our DB.
  const order = yield select(getOrder, uuid)
  const itemModels = order?.itemModels ?? makeLineItemData(lineItems)

  const taxRate = yield select(getTaxRate)
  const taxByItem = yield select(getTaxByItem)
  const serviceCharge = yield select((state) => getMenuServiceCharge(state))
  const originalTransactionId = cardReaderData?.uuid || ''
  const isBackBar = yield select(getBackbarMode)

  const discountAmountInCents = remoteOrderTotal?.discountAmountInCents ?? 0
  let subtotalAmountInCents, serviceFee, taxAmountInCents, amountInCents
  let calculateTaxResult
  let taxRulesBreakdown = {}

  if (remoteOrderTotal?.isAvailable) {
    //use remote order total values when available
    subtotalAmountInCents = remoteOrderTotal.subtotalInCents
    serviceFee = {
      name: remoteOrderTotal.serviceChargeName,
      total: remoteOrderTotal.serviceChargeInCents ?? 0,
      legal: remoteOrderTotal.serviceChargeLegal,
    }
    taxAmountInCents = remoteOrderTotal.taxAmountInCents ?? 0
    amountInCents = remoteOrderTotal?.totalAmountInCents ?? 0
    taxRulesBreakdown = remoteOrderTotal?.taxRulesBreakdown || {}
  } else {
    // when remote order total is not available calculate values
    subtotalAmountInCents = calculateSubtotal(lineItems)
    serviceFee = {
      name: serviceCharge.name,
      total: calculateServiceCharge(serviceCharge, subtotalAmountInCents) ?? 0,
      legal: serviceCharge.legal,
      taxable: serviceCharge.taxable,
      taxClassUuid: serviceCharge?.taxClassUuid,
    }

    calculateTaxResult = calculateTax(
      lineItems,
      taxRate,
      taxByItem,
      useNormalTaxRounding,
      useTaxClasses,
      taxClasses,
      taxRules,
      taxExempt,
    )
    taxRulesBreakdown = calculateTaxResult.taxRulesBreakdown || {}

    let serviceFeeTaxAmountInCents = 0

    if (useTaxClasses) {
      const calculateServiceFeeTaxRulesResult = calculateServiceFeeTaxRules(
        taxRulesBreakdown,
        serviceFee,
        useNormalTaxRounding,
        taxClasses,
        taxRules,
        taxExempt,
      )
      serviceFeeTaxAmountInCents = calculateServiceFeeTaxRulesResult.serviceFeeTaxAmountInCents
      taxRulesBreakdown = calculateServiceFeeTaxRulesResult.taxRulesBreakdown || {}
    } else {
      serviceFeeTaxAmountInCents = calculateIndividualTaxAmount(
        taxRate,
        serviceFee.total,
        serviceFee.taxable,
        useNormalTaxRounding,
      )
    }

    taxAmountInCents = calculateTaxResult.taxAmountInCents + serviceFeeTaxAmountInCents

    amountInCents = subtotalAmountInCents + taxAmountInCents + serviceFee.total
  }

  const balanceDueInCents = amountInCents
  const tipAmountInCents = 0

  let userAttributes
  let userName
  if (cardReaderData) {
    userAttributes = makeUserAttributes(cardReaderData, PAYMENT_TYPES_INTERNAL.SAVED_CARD)
    userName = getUserNameFromCard(cardReaderData)
  }

  const payment = {
    paymentId,
    paymentType,
    amountInCents,
    orderNumber,
    tipAmountInCents,
    shortDescription,
  }

  if (isCreditType(paymentType)) {
    payment.userAttributes = userAttributes
    payment.userName = userName
    payment.cardType = userAttributes?.freedompayIssuerName
    payment.label = cardReaderData?.cardType
    payment.shortDescription = `${userAttributes?.freedompayIssuerName} ${userAttributes?.last_4}`
  }

  let promotions = yield select(getSelectedPromotions)
  if (isEmpty(promotions)) {
    promotions = undefined
  }

  const createOrderParams = {
    ...makeCreateOrderParams({
      employeeId,
      isTab: false,
      itemModels,
      menuUuid,
      orderNumber,
      orderState,
      submittedAt,
      uuid,
      affiliations: null,
      promotions,
      userNotes,
      shortDescription: payment.shortDescription,
      paymentType,
      amountInCents,
      originalClientCreatedAt: getCreateOrderParams(order)?.clientCreatedAt,
    }),
    state: STADIUM_ORDER_STATES.TABBED,
    userAttributes,
    userName: tabName,
  }

  const isFreeOrder = amountInCents === 0
  //we need to flag the payment as preserved for reopen on backbar
  if ((isBackBar && payment?.userAttributes) || isFreeOrder) {
    if (!payment.userAttributes) payment.userAttributes = {}
    payment.userAttributes.preservePaymentAfterReopen = true
  }

  const orderData = {
    ...createOrderParams,
    itemModels,
    menuSubtype,
    orderNumber,
    revenueCenterUuid,
    revenueName,
    submittedAt,
    tabName,
    uuid,
    payments: [payment],
    subtotalAmountInCents,
    cardReaderData,
    originalTransactionId,
    taxAmountInCents,
    amountInCents,
    balanceDueInCents,
    tipAmountInCents,
    discountAmountInCents,
    isTab: true,
    state: STADIUM_ORDER_STATES.TABBED,
    invoiceNumber: userAttributes?.freedompayInvoiceNumber,
    userNotes,
    serviceFee,
    taxRulesBreakdown,
    userAttributes: {
      ...createOrderParams.userAttributes,
      isBackBar,
    },
    taxExempt,
    taxExemptReason,
    taxExemptApproverUuid: taxExempt ? taxExemptApproverUuid : '',
  }

  if (!cardReaderData && !paymentType) {
    createOrderParams.payments = []
    orderData.payments = []
    delete orderData.invoiceNumber
  }

  if (cardReaderData && isOfflineApproval({ cardReaderData })) {
    createOrderParams.state = STADIUM_ORDER_STATES.TABBED_OFFLINE
    orderData.state = STADIUM_ORDER_STATES.TABBED_OFFLINE
    yield put(saveOfflineOrder(ensureRelatedInvoiceNumbers(orderData)))
  } else {
    orderData.isSyncing = true
    yield put(saveOrder(ensureRelatedInvoiceNumbers(orderData)))
  }

  yield put(clearRemoteOrderTotal())
  yield put(clearPromotionsOnOrder())
  yield put(clearCart())
  yield put(syncOrderRequested({ orderUuid: uuid, printAuth }))

  if (cfdMode === MODES.POS) {
    resetCFDrequest()
    yield put(setCalculatedCurrentCartValues({}))
    yield put(resetCFD(true))
  }

  ToastManager.success(APPLICATION_STRINGS.TAB_STARTED)
  yield put(stopSpinner())

  if (redirectPath) {
    yield put(setRouteAction(redirectPath))
  }
}

export function* addItemsToTab(params = {}) {
  const order = yield select(getOrderInProgress)
  const cartItems = yield select(getCartItems)
  const newLineItems = makeCreateOrderLineItems(makeLineItemData(cartItems))
  const failureCallback = params.payload?.failureCallback
  const promotions = order?.promotions || []
  let userNotes = get(params, 'payload.userNotes')
  const orderNotes = yield select(getOrderNotes)

  if (!userNotes) userNotes = yield select(getCartNotes)

  if (orderNotes) {
    userNotes = userNotes ? `${userNotes?.split('\nNote:')[0]}\n${orderNotes}` : `\n${orderNotes}`
  }

  try {
    const result = yield call(MutationApi.addLineItems, order.uuid, newLineItems, userNotes)

    const applied = result?.data?.orderMutations?.[0]?.applied

    if (applied) {
      /**
       * if the order already has promotions applied (this can only happen in backbar mode)
       * we'll try to re apply them using the updateTotals mutation, if discounts can't be applied
       * keep processing and show a toast
       */
      if (promotions.length) {
        const updateTotalsResult = yield call(MutationApi.updateTotals, { orderUuid: order.uuid, promotions })
        const updateTotalsApplied = updateTotalsResult?.data?.orderMutations?.[0]?.applied

        if (!updateTotalsApplied) {
          ToastManager.error('Failed to re apply discounts')
        }
      }

      yield put(addItemsToTabSucceeded({ orderId: order.uuid, userNotes }))
      yield put(orderDetailsRequested(order.uuid))
      yield put(clearCart())
      yield put(clearOrderInProgress())
      yield put(clearPromotionsOnOrder())

      yield put(stopSpinner())

      if (result?.data?.orderMutations?.[0]?.friendlyMessage?.length) {
        ToastManager.error(result.data.orderMutations[0].friendlyMessage, { autoClose: false })
      }

      ToastManager.success(APPLICATION_STRINGS.TAB_UPDATED)
      return
    }

    // failed to apply item
    throw new Error('Failed to add items to tab')
  } catch (e) {
    yield put(addItemsToTabFailed())
    yield put(orderDetailsRequested(order.uuid))
    yield put(clearCart())
    yield put(clearOrderInProgress())
    yield put(clearPromotionsOnOrder())
    ToastManager.error(APPLICATION_STRINGS.TAB_UPDATE_FAILED, { autoClose: false })
    yield put(stopSpinner())
    if (typeof failureCallback === 'function') {
      failureCallback()
    }
  }
}

export function* addDiscountsToTabOrderSaga(params = {}) {
  const order = yield select(getOrderInProgress)
  const promotions = yield select(getSelectedPromotions)

  //if we're adding discounts then we need to send auto applied discounts to the updateTotals calls or we'll lose them
  const autoAppliedPromotions = order.promotions?.filter((promotion) => promotion.redemptionMethod === 'auto') || []

  try {
    const result = yield call(MutationApi.updateTotals, {
      orderUuid: order.uuid,
      promotions: [...promotions, ...autoAppliedPromotions],
    })
    const applied = result?.data?.orderMutations?.[0]?.applied

    if (applied) {
      yield call(getOrderDetails, { payload: { orderUuid: order.uuid } })
      yield put(setOrderInProgressWithId(order.uuid))

      //get applied promotions from lineItems and push their uuids in a single array
      const allAppliedPromotions = result?.data?.orderMutations?.[0]?.lineItems
        .map((item) => item.promotions)
        .filter((promotions) => promotions !== null)
        .reduce((acc, promotions) => {
          return acc.concat(promotions.map((promotion) => promotion.uuid))
        }, [])

      //check if some promotion was not applied
      const notAllPromotionsApplied = promotions.some((promotion) => !allAppliedPromotions.includes(promotion.uuid))

      if (notAllPromotionsApplied) {
        ToastManager.error(APPLICATION_STRINGS.PROMOTIONS_NOT_APPLIED)
      } else {
        if (allAppliedPromotions.length) {
          ToastManager.success(APPLICATION_STRINGS.DISCOUNTS_APPLIED)
        }
      }

      //filter local state applied promotions and update state
      const selectedPromotions = promotions.filter((promotion) => allAppliedPromotions.includes(promotion.uuid))

      yield put(addPromotionsToOrder({ selectedPromotions }))

      yield call(directTo, 'push', { pathname: '/tender-selection', state: { fromDiscounts: true, fromDiscountsCancel: false } })
      return
    }

    ToastManager.error(APPLICATION_STRINGS.PROMOTIONS_NOT_APPLIED)
    yield call(directTo, 'push', { pathname: '/tender-selection', state: { fromDiscounts: true, fromDiscountsCancel: false } })
  } catch (e) {
    ToastManager.error(APPLICATION_STRINGS.PROMOTIONS_NOT_APPLIED)
    yield put(clearCart())
    yield put(clearOrderInProgress())
    yield call(directTo, 'push', '/orders')
  }
}

export function* deleteDiscountsFromTabOrderSaga(params = {}) {
  const order = yield select(getOrderInProgress)

  //if we're deleting discounts then we need to send auto applied discounts to the updateTotals calls or we'll lose them
  const autoAppliedPromotions = order.promotions?.filter((promotion) => promotion.redemptionMethod === 'auto') || []

  try {
    const result = yield call(MutationApi.updateTotals, { orderUuid: order.uuid, promotions: [...autoAppliedPromotions] })
    const applied = result?.data?.orderMutations?.[0]?.applied

    if (applied) {
      yield put(orderDetailsRequested(order.uuid))
      return
    }
    ToastManager.error(APPLICATION_STRINGS.PROMOTIONS_NOT_APPLIED)
  } catch (e) {
    ToastManager.error(APPLICATION_STRINGS.PROMOTIONS_NOT_APPLIED)
  }
}

export function* addItemsToTabOffline(params = {}) {
  const order = yield select(getOrderInProgress)
  const orderId = order.uuid
  const lineItems = yield select(getCartItems)
  const itemModels = makeLineItemData(lineItems)
  const orderMenuItems = makeCreateOrderLineItems(itemModels)
  let promotions = yield select(getSelectedPromotions)
  if (isEmpty(promotions)) {
    promotions = undefined
  }

  const taxRate = yield select(getTaxRate)
  const taxByItem = yield select(getTaxByItem)
  const serviceCharge = yield select((state) => getMenuServiceCharge(state))
  const useNormalTaxRounding = yield select(getUseNormalTaxRounding)
  const taxClasses = yield select(getTaxClasses)
  const taxRules = yield select(getTaxRules)
  const useTaxClasses = yield select(getUseTaxClasses)
  const taxExempt = yield select(getIsOrderTaxExempt)

  //if the order is exempted we need to pull the breakdown from exemptableTaxRules
  let taxRulesBreakdown = taxExempt ? cloneDeep(order.exemptableTaxRules) : cloneDeep(order.taxRulesBreakdown)

  // for offline tabbed orders we need to update calculations
  const subtotalAmountInCents = calculateSubtotal(lineItems)
  const serviceFee = {
    name: serviceCharge.name,
    //calculate service charge with 3rd parameter = false will return the service charge without the flat fee
    //which was already added to the order when created.
    total: calculateServiceCharge(serviceCharge, subtotalAmountInCents, false) ?? 0,
    legal: serviceCharge.legal,
    taxClassUuid: serviceCharge?.taxClassUuid,
  }

  const calculateTaxResult = calculateTax(
    lineItems,
    taxRate,
    taxByItem,
    useNormalTaxRounding,
    useTaxClasses,
    taxClasses,
    taxRules,
    false, //always recalculate taxes even if exempted
  )

  let serviceFeeTaxAmountInCents = 0

  if (useTaxClasses) {
    const calculateServiceFeeTaxRulesResult = calculateServiceFeeTaxRules(
      taxRulesBreakdown,
      serviceFee,
      useNormalTaxRounding,
      taxClasses,
      taxRules,
      false, //always recalculate taxes even if exempted
    )
    serviceFeeTaxAmountInCents = calculateServiceFeeTaxRulesResult.serviceFeeTaxAmountInCents
    taxRulesBreakdown = calculateServiceFeeTaxRulesResult.taxRulesBreakdown || {}
  } else {
    serviceFeeTaxAmountInCents = calculateIndividualTaxAmount(taxRate, serviceFee.total, serviceFee.taxable, useNormalTaxRounding)
  }

  const taxAmountInCents = calculateTaxResult.taxAmountInCents + serviceFeeTaxAmountInCents

  const amountInCents = subtotalAmountInCents + taxAmountInCents + serviceFee.total
  const balanceDueInCents = amountInCents

  const payments = (order?.payments || []).map((payment, idx) => {
    if (idx === 0) {
      return {
        ...payment,
        amountInCents: amountInCents + order?.amountInCents,
      }
    }
    return payment
  })

  //apply accumulative tax breakdown to order
  Object.keys(calculateTaxResult.taxRulesBreakdown).forEach((ruleId) => {
    const rule = calculateTaxResult.taxRulesBreakdown[ruleId]
    if (taxRulesBreakdown[ruleId]) {
      taxRulesBreakdown[ruleId].taxRuleAmountInCents += rule.taxRuleAmountInCents
      return
    }

    taxRulesBreakdown[ruleId] = rule
  })

  if (!taxExempt) {
    yield put(
      addItemsToOrder({
        orderMenuItems,
        itemModels,
        orderId,
        subtotalAmountInCents,
        taxAmountInCents,
        amountInCents,
        balanceDueInCents,
        promotions,
        payments,
        serviceFee,
        taxRulesBreakdown,
      }),
    )
  } else {
    const exemptedAmountInCents = subtotalAmountInCents + serviceFee.total
    yield put(
      addItemsToOrder({
        orderMenuItems,
        itemModels,
        orderId,
        subtotalAmountInCents,
        taxAmountInCents: 0,
        amountInCents: exemptedAmountInCents,
        balanceDueInCents: exemptedAmountInCents,
        promotions,
        payments,
        serviceFee,
        taxRulesBreakdown: {},
        exemptableTaxRules: taxRulesBreakdown, //new tax calculation is stored in exemptableTaxRules
      }),
    )
  }
  yield put(clearCart())
  yield put(clearOrderInProgress())
  yield put(syncOrderRequested({ orderUuid: orderId }))

  ToastManager.success(APPLICATION_STRINGS.TAB_UPDATED)
  yield put(stopSpinner())
}

export function* startOfflineCardOrder(params = {}) {
  const isKiosk = get(params, 'payload.isKiosk', false)
  const employeeId = yield verifyCurrentAttendant(isKiosk)
  if (employeeId === undefined) return

  const useNormalTaxRounding = yield select(getUseNormalTaxRounding)
  const taxClasses = yield select(getTaxClasses)
  const taxRules = yield select(getTaxRules)
  const useTaxClasses = yield select(getUseTaxClasses)
  const taxExempt = yield select(getIsOrderTaxExempt)
  const taxExemptData = yield select(getTaxExemptData)
  const taxExemptReason = taxExemptData?.reason || ''
  const taxExemptApproverUuid = yield select(getTaxExemptApproverUuid)

  const cardReaderData = params?.payload?.cardReaderData ?? {}
  const signature = params?.payload?.signature
  const invoiceNumber = params?.payload?.invoiceNumber
  const charityAmountInCents = parseInt(params?.payload?.charityAmountInCents ?? 0)
  const tipAmountInCents = parseInt(params?.payload?.tipAmountInCents ?? 0)
  const orderNumber = cardReaderData?.orderNumber ?? params?.payload?.orderNumber
  const submittedAt = Date.now()
  const paymentCompleted = cardReaderData.transType === 'sale'
  const orderState = get(params, 'payload.orderState', INTERNAL_ORDER_STATES.CLOSED)

  const { menuUuid, revenueCenterUuid, revenueName } = yield menuAndRvcUuids(isKiosk)
  const menu = yield select((state) => getCurrentMenu(state))
  const menuSubtype = get(menu, 'subtype')

  // for kiosk orders, we're passing in line items to avoid race condition of cart being cleared
  // when redirecting to the attract loop
  let lineItems = get(params, 'payload.lineItems')
  if (!lineItems) lineItems = yield select(getCartItems)

  let userNotes = get(params, 'payload.userNotes')
  const orderNotes = yield select(getOrderNotes)
  if (!userNotes) userNotes = yield select(getCartNotes)

  if (orderNotes) {
    userNotes = userNotes ? `${userNotes?.split('\nNote:')[0]}\n${orderNotes}` : `\n${orderNotes}`
  }

  if (isEmpty(lineItems) && !isKiosk) {
    yield call(directTo, 'push', '/concession-order')
    createDataDogLog('error', APPLICATION_STRINGS.ORDER_ONE_ITEM)
    return
  }

  const uuid = yield select((state) => getOrderSubumissionUuid(state, cardReaderData?.uuid))

  // Perhaps this is another attempt to trigger the creation of an order already in our DB.
  const order = yield select(getOrder, uuid)
  const itemModels = order?.itemModels ?? makeLineItemData(lineItems)

  const taxRate = yield select(getTaxRate)
  const taxByItem = yield select(getTaxByItem)
  const remoteOrderTotal = yield select(getRemoteOrderTotal)
  const discountAmountInCents = remoteOrderTotal?.discountAmountInCents ?? 0

  let taxAmountInCents
  let calculateTaxResult
  let taxRulesBreakdown = {}

  if (remoteOrderTotal?.isAvailable) {
    taxAmountInCents = remoteOrderTotal?.taxAmountInCents ?? 0
    taxRulesBreakdown = remoteOrderTotal?.taxRulesBreakdown || {}
  } else {
    calculateTaxResult = calculateTax(
      lineItems,
      taxRate,
      taxByItem,
      useNormalTaxRounding,
      useTaxClasses,
      taxClasses,
      taxRules,
      taxExempt,
    )
    taxAmountInCents = calculateTaxResult.taxAmountInCents
    taxRulesBreakdown = calculateTaxResult?.taxRulesBreakdown || {}
  }

  let subtotalAmountInCents = remoteOrderTotal?.subtotalInCents ?? calculateSubtotal(lineItems)
  let amountInCents =
    (remoteOrderTotal?.totalAmountInCents ?? subtotalAmountInCents + taxAmountInCents) + tipAmountInCents + charityAmountInCents
  let serviceFee = { name: 'Service Charge', total: 0, legal: null }

  // Recalibrate the subtotal and total based on whether or not there is a remote total.
  if (!isNil(remoteOrderTotal?.totalAmountInCents)) {
    // When there is a remote total, the subtotal is present and properly calculated.
    serviceFee = {
      name: remoteOrderTotal?.serviceChargeName,
      total: remoteOrderTotal?.serviceChargeInCents ?? 0,
      legal: remoteOrderTotal.serviceChargeLegal,
    }
  } else {
    // When there is no remote total, the service fee needs to be calculated and added into the
    // total but not the subtotal.
    const serviceCharge = yield select((state) => getMenuServiceCharge(state))
    serviceFee = {
      name: serviceCharge.name,
      total: calculateServiceCharge(serviceCharge, subtotalAmountInCents) ?? 0,
      legal: serviceCharge.legal,
      taxClassUuid: serviceCharge?.taxClassUuid,
    }

    let serviceFeeTaxAmountInCents = 0

    if (useTaxClasses) {
      const calculateServiceFeeTaxRulesResult = calculateServiceFeeTaxRules(
        taxRulesBreakdown,
        serviceFee,
        useNormalTaxRounding,
        taxClasses,
        taxRules,
        taxExempt,
      )
      serviceFeeTaxAmountInCents = calculateServiceFeeTaxRulesResult.serviceFeeTaxAmountInCents
      taxRulesBreakdown = calculateServiceFeeTaxRulesResult.taxRulesBreakdown || {}
    } else {
      serviceFeeTaxAmountInCents = calculateIndividualTaxAmount(
        taxRate,
        serviceFee.total,
        serviceCharge.taxable,
        useNormalTaxRounding,
      )
    }

    taxAmountInCents += serviceFeeTaxAmountInCents
    amountInCents = amountInCents + serviceFee.total + serviceFeeTaxAmountInCents
  }

  const userAttributes = makeUserAttributes(cardReaderData)
  if (invoiceNumber && !userAttributes.freedompayInvoiceNumber) {
    userAttributes.freedompayInvoiceNumber = invoiceNumber
  }
  let promotions = yield select(getSelectedPromotions)
  if (isEmpty(promotions) || !remoteOrderTotal.isAvailable) {
    promotions = undefined
  }

  const shortDescription = userAttributes?.freedompayIssuerName
    ? `${userAttributes?.freedompayIssuerName} ${userAttributes?.last_4}`
    : undefined

  const createOrderParams = {
    ...makeCreateOrderParams({
      amountInCents,
      charityAmountInCents,
      tipAmountInCents,
      employeeId,
      isTab: false,
      itemModels,
      menuUuid,
      orderNumber,
      orderState,
      paymentType: 'freedompay_credit',
      submittedAt,
      uuid,
      affiliations: null,
      signature,
      promotions,
      userNotes,
      shortDescription,
      originalClientCreatedAt: getCreateOrderParams(order)?.clientCreatedAt,
    }),
    state: STADIUM_ORDER_STATES.APPROVED_OFFLINE,
    userAttributes: userAttributes,
    userName: getUserNameFromCard(cardReaderData),
  }

  const orderData = {
    ...createOrderParams,
    amountInCents,
    charityAmountInCents,
    tipAmountInCents,
    taxAmountInCents,
    subtotalAmountInCents,
    discountAmountInCents,
    balanceDueInCents: 0,
    serviceFee,
    cardReaderData,
    itemModels,
    menuSubtype,
    orderNumber,
    paymentCompleted,
    revenueCenterUuid,
    revenueName,
    signature,
    submittedAt,
    uuid,
    invoiceNumber: userAttributes.freedompayInvoiceNumber,
    userNotes,
    taxRulesBreakdown,
    taxExempt,
    taxExemptReason,
    taxExemptApproverUuid: taxExempt ? taxExemptApproverUuid : '',
  }

  yield put(clearRemoteOrderTotal())
  yield put(saveOfflineOrder(ensureRelatedInvoiceNumbers(orderData)))
  if (remoteOrderTotal?.isAvailable) {
    yield put(syncOrderInitiated(uuid))
    yield put(syncOfflineOrderRequested(uuid))
  }
}

const REPLAY_MAXIMUM_PAYMENTS = 10
// We just sent a request to FreedomPay to replay all offline approvals fro mthe card reader.
// Here we check the status for particular orders after that is initiated.
export function* getReplayAuthStatus(orderRequest, curOfflineRequestId = null, currentAttempt = 0) {
  const order = cloneDeep(orderRequest)
  const id = order.uuid
  const cfdMode = yield select(getDeviceMode)

  // handle unique invoice numbers per transaction for multiple payments
  const hasInvoiceNumberPerTransaction = yield select((state) =>
    isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.UNIQUE_INVOICE_NUMBERS),
  )

  // add back any payments that needed to be voided
  if (order.neededToBeVoidedAuthPayment && Array.isArray(order.neededToBeVoidedAuthPayment)) {
    order.payments = [...order.payments, ...order.neededToBeVoidedAuthPayment]
    order.neededToBeVoidedAuthPayment = null
  }

  const offlineRequestId = curOfflineRequestId || orderReplayRequestId(order)
  if (!offlineRequestId) {
    yield put(replayAuthRequestFailed({ order, replayStatus: { statusDisplay: 'No request ID for card reader' } }))
    createDataDogLog('error', 'No request ID for card reader')
    return
  }

  const bridgeInstance = PeripheralBridge.getBridge()
  if (!bridgeInstance) {
    yield put(replayAuthRequestFailed({ order, replayStatus: { statusDisplay: 'Could not reach the card reader' } }))
    return
  }

  try {
    const checkStatusPromise = new Promise((resolve, reject) => {
      // we only run to turn on replayAuthStatus if the connected device has a CFD
      // due to the remote connection and having broadPOS on the other device
      if (cfdMode === MODES.POS) {
        bridgeInstance.registerHandler('replayAuthStatus', (data) => resolve(data))
        bridgeInstance.callHandler('checkStatus', { requestId: offlineRequestId })
      } else {
        bridgeInstance.callHandler('checkStatus', { requestId: offlineRequestId }, (data) => resolve(data))
      }

      setTimeout(() => {
        reject()
      }, MS_GATEWAY_FORCE_CONTINUE)
    })

    const statusData = yield checkStatusPromise

    // Offline orders will have an empty token (PAX specific)
    // When an order is closed offline, the order will be marked as completed and, at that point, we'd want to send an update to Stadium
    // current order does not have token, but statusData has a token
    const needsCardToken = (order) => {
      // no token found in checkStatusPromise response
      if (!statusData.tokenInformation?.token) return false
      if (curOfflineRequestId) return true
      if (!hasInvoiceNumberPerTransaction) {
        return !getCreateOrderParams(order)?.userAttributes?.token
      }
      return order.payments?.some((payment) => !payment.userAttributes?.token)
    }

    // If an order's platform state is in completed status, it might mean that the order
    // was completed on a different device and we should abort this process to avoid overwriting
    // any changes that might not have synced/updated correctly to this device (tips, discounts, affiliations etc) on the order's createOrderParams
    // there may be a better mitigation for this in the future but would require more data such as promotions being retrieved by the fetch orders request
    if (
      (order?.state === STADIUM_ORDER_STATES.COMPLETION_PENDING || order?.state === STADIUM_ORDER_STATES.COMPLETED) &&
      !needsCardToken(order)
    ) {
      yield put(saveOrder(ensureRelatedInvoiceNumbers(order), false, true))
      return
    }

    if (!statusData) {
      yield put(replayAuthRequestFailed({ order, replayStatus: { statusDisplay: 'Request ID does not exists' } }))
      createDataDogLog('error', 'Request ID does not exists')
      return
    }

    const replayStatus = {
      ...statusData,
      statusDisplay: responseStatusString(statusData.responseStatus),
    }

    // Auth "NOT FOUND", the SAF batch likely already closed/uploaded externally
    if (approvedOfflineNoResponse(statusData) && isOfflineApproval(order)) {
      createDataDogLog('error', '[Replay Auth] - SAF likely already uploaded (receiving a NOT FOUND)', { order })
    }

    if (!statusCheckComplete(statusData)) {
      yield put(replayAuthRequestFailed({ order, replayStatus }))
      createDataDogLog('error', 'Replay Status Check Failed', { order, replayStatus })
      return
    }

    let createOrderParams = { ...getCreateOrderParams(order) }

    // update order state for stadium based on freedompay status
    const isDeclined = approvedOfflineThenDeclined(statusData)

    // If the status check produced no real response, we should not update the order state.
    if (!approvedOfflineNoResponse(statusData)) {
      createOrderParams.state = isDeclined ? STADIUM_ORDER_STATES.AUTHORIZATION_FAILED : STADIUM_ORDER_STATES.COMPLETED
    }

    // Handle syncing orders from a Submitted State
    if (order?.state === STADIUM_ORDER_STATES.SUBMITTED) {
      const mappedAuth = mapCardReaderDataForSubmittedOrder(createOrderParams, statusData)

      replayStatus.statusDisplay = mappedAuth.reason
      createOrderParams = {
        ...createOrderParams,
        ...mappedAuth,
      }
    }

    if (isTabbed(order) && isOfflineApproval(order) && (getIsPreAuthTab(order) || order.reopened)) {
      createOrderParams.isTab = true
      createOrderParams.state = STADIUM_ORDER_STATES.TABBED

      if (isDeclined) createOrderParams.state = STADIUM_ORDER_STATES.AUTHORIZATION_FAILED
    }

    // ensure userAttributes is defined
    if (!createOrderParams.userAttributes) {
      createOrderParams.userAttributes = {}
    }

    // Need to do the below checks verbose-ly so that we don't mess up any
    // existing offline functionality with FreedomPay as this is maybe
    // PAX specific

    if (!isEmpty(statusData.authResponseData?.authorizationCode)) {
      createOrderParams.userAttributes.authorizationCode = statusData.authResponseData.authorizationCode
    }

    if (!isEmpty(statusData.receiptData?.approvalCode)) {
      createOrderParams.userAttributes.approvalCode = statusData.receiptData.approvalCode
    }

    if (!isEmpty(statusData.receiptData?.authStatus)) {
      createOrderParams.userAttributes.authStatus = statusData.receiptData.authStatus
    }

    if (!isEmpty(statusData.tokenInformation?.token)) {
      createOrderParams.userAttributes.token = statusData.tokenInformation.token
      createOrderParams.userAttributes.isOfflineApproval = false

      // reopen tabbed_offline tabs need token to settle
      if (order?.reopened && order?.paymentInfo.length === 1 && !order.payments?.length) {
        const stashedPayment = yield select((state) => getReopenedTabPayments(state, order.uuid))
        if (stashedPayment?.size) {
          const reopenedPayment = stashedPayment.first()
          const paymentWithToken = {
            ...reopenedPayment,
            userAttributes: {
              ...reopenedPayment.userAttributes,
              token: statusData.tokenInformation.token,
            },
          }
          yield put(setReopenedTabPaymentsAction({ orderUuid: order.uuid, payments: [paymentWithToken] }))
        }
      }

      // set token in payment userAttributes
      createOrderParams.payments = (order.payments || []).map((orderPayment) => {
        const payment = cloneDeep(orderPayment)
        if (payment.userAttributes?.freedompayInvoiceNumber === offlineRequestId) {
          payment.userAttributes.token = statusData.tokenInformation.token
          payment.userAttributes.isOfflineApproval = false
        }

        // single payment does not contain any userAttributes. Copy from order level
        if (!payment.userAttributes && createOrderParams.payments.length === 1) {
          payment.userAttributes = { ...createOrderParams.userAttributes }
        }

        // remove nested userAttributes
        if (payment.userAttributes?.userAttributes) {
          delete payment.userAttributes.userAttributes
        }
        return payment
      })
    }

    // need to update the freedom pay request id for refunds to work
    createOrderParams.userAttributes.freedompayRequestId = statusData.realRequestId
    createOrderParams.userAttributes.isOfflineApproval = false
    const cardReaderData = {
      ...order.cardReaderData,
      requestId: statusData.realRequestId,
      isOfflineApproval: false,
    }

    if (hasInvoiceNumberPerTransaction && order.payments?.length > 1) {
      const resultingOrder = { ...order, ...createOrderParams, cardReaderData, isDeclined }
      const nextInvoiceNumber = order.payments?.find(
        (p) => isCreditType(p.paymentType) && p.userAttributes?.freedompayInvoiceNumber && !p.userAttributes?.token,
      )?.userAttributes?.freedompayInvoiceNumber

      // recursive call until all payments have been updated with tokens up to 10 payments
      if (nextInvoiceNumber && currentAttempt < REPLAY_MAXIMUM_PAYMENTS) {
        yield call(getReplayAuthStatus, resultingOrder, nextInvoiceNumber, currentAttempt + 1)
        return
      }

      // when more than one payment, remove order-level userAttributes
      if (curOfflineRequestId) {
        const preservedInvoiceNumbers = order.userAttributes?.relatedInvoiceNumbers
        order.userAttributes = preservedInvoiceNumbers ? { relatedInvoiceNumbers: preservedInvoiceNumbers } : undefined
      }
    }

    // keep state cancelled for tabs
    if (order.isTab && order.state === STADIUM_ORDER_STATES.CANCELLED) {
      createOrderParams.state = STADIUM_ORDER_STATES.CANCELLED
    }

    // remove userAttributes when multiple payments to prevent stadium rejection
    const hasMultipleCreditPayments = order.payments?.filter((payment) => isCreditType(payment.paymentType))?.length > 1
    if (hasInvoiceNumberPerTransaction && hasMultipleCreditPayments) {
      const preservedInvoiceNumbers =
        createOrderParams.userAttributes?.relatedInvoiceNumbers || order.userAttributes?.relatedInvoiceNumbers
      createOrderParams.userAttributes = preservedInvoiceNumbers ? { relatedInvoiceNumbers: preservedInvoiceNumbers } : {}
    }

    yield put(saveOrder({ ...order, cardReaderData, ...createOrderParams, isDeclined }))
    yield put(replayAuthRequestSucceeded({ replayStatus, order }))

    // RC orders should not be synced here, as they will already be synced
    if (order.isRichCheckout && isOfflineApproval(order)) {
      return
    }

    // scanned tenders tabs and non-tabs update token via mutation
    const updateWithMutation = orderIsScannedTender(order) || order.isTab
    if (needsCardToken(order) && updateWithMutation) {
      try {
        let updatedOrder = {}
        Object.assign(updatedOrder, { ...order, ...createOrderParams })

        if (yield call(applyAuthTokenWithMutation, updatedOrder)) {
          // for scanned tenders that are not tabs, we need to close
          if (!order.isTab) {
            const closePayload = {
              orderId: order.uuid,
              receiptSignature: order?.signature ?? order?.receiptSignature,
              charityAmountInCents: order?.charityAmountInCents,
              tipAmountInCents: order?.tipAmountInCents,
              userName: getCreateOrderParams(order)?.userName,
              taxExempt: order?.taxExempt ?? false,
              cashRounded: order?.cashRounded ?? false,
            }

            // it's called "closeTabOrder" but it works for non-tabs
            const result = yield call(MutationApi.closeTabOrder, closePayload)

            if (result?.data?.orderMutations?.[0]?.applied) {
              yield put(saveOrder({ ...order, state: STADIUM_ORDER_STATES.COMPLETED }, false))
            }
          }
          return
        }
      } catch {
        ToastManager.error(APPLICATION_STRINGS.UPDATE_PAYMENT_FAILED, { autoClose: false })
        return
      }
    }

    if (!isTabbed(order)) {
      yield put(syncOfflineOrderRequested(id))
    } else {
      yield put(syncOrderRequested({ orderUuid: id }))
    }
  } catch (err) {
    yield put(replayAuthRequestFailed({ order, replayStatus: { statusDisplay: 'Check Status for order timed out' } }))
    createDataDogLog('error', 'Replay Auth Failed', {
      order,
      replayStatus: { statusDisplay: err?.message || 'Check Status for order timed out' },
    })
    return
  }
}

// Update the unsyncability of an order if it has exceeded the maximum number of retries.
const updateNextSync = (order) => {
  const syncAttempt = order.syncAttempts ?? 0
  order.syncAttempts = syncAttempt + 1

  return order
}

export function* syncOrders() {
  const orderIds = yield select((state) => getOfflineLocalIds(state))

  if (orderIds.length > 0) {
    createDataDogLog('info', 'Sync Offline Local IDs Started', { offlineLocalIds: orderIds })
    ToastManager.info('A sync to VenueNext is beginning.', { autoClose: 2000 })
  }

  for (var i = 0; i < orderIds.length; i++) {
    var dataIsUploading = yield select(getDataIsUploading)
    if (!dataIsUploading) {
      return
    }

    try {
      yield put(
        syncOrderRequested({ orderUuid: orderIds[i], displayOrderToast: false, offlineOrder: true, fromSyncOrders: true }),
      )
      yield delay(5000)
    } catch (error) {
      // TODO(mkramerl): Turn these into set error actions and display them in the UI.
      ToastManager.error(`Error platform syncing ${orderIds[i]} : ${error}`, { autoClose: false })
      createDataDogLog('error', `Error platform syncing ${orderIds[i]} : ${error}`)
    }
  }

  yield put(setDataIsUploading(false))
}

export function* syncOrdersReplayAuth() {
  const orderIds = yield select((state) => getOrderIdsToStateSync(state, true))

  createDataDogLog('info', 'Sync Offline Card IDs Started', { offlineCardIds: orderIds })

  // Do the array in reverse order so that the most recent orders are processed first.
  for (var i = orderIds.length - 1; i >= 0; i--) {
    yield put(setSafStatusProgress(i + 1))

    var safStatusRequesting = yield select(getSafStatusRequesting)
    if (!safStatusRequesting) return

    const order = yield select(getOrder, orderIds[i])
    const orderRequestId = orderReplayRequestId(order)
    if (!orderRequestId) {
      createDataDogLog('error', `Order ${orderIds[i]} does not have a request ID for replaying`)
      //if we don't have an orderRequestId then we need to stop this iteration and not call replayAuthRequested
      //TODO T36835: remove this continue statement once we delete offlineCardIds when changing payment types on an auth tab
      continue
    }

    try {
      // Adjust the order to be the most recent one that was saved to the store. Otherwise we might
      // be updating an order that has already been synced.
      const latestOrder = yield select(getOrder, orderIds[i])
      yield put(replayAuthRequested(latestOrder))
      yield delay(5000)
    } catch (error) {
      // TODO(mkramerl): Turn these into set error actions and display them in the UI.
      ToastManager.error(`Error processor syncing ${orderIds[i]} : ${error}`, { autoClose: false })
      createDataDogLog('error', `Error processor syncing ${orderIds[i]} : ${error}`)
    }
  }

  createDataDogLog('info', 'Sync Offline Card IDs Finished', { orderIds })

  const androidSDKVersion = yield select(getAndroidSDKVersion)
  const purgeableAndroidVersion = isSDKCompatible(androidSDKVersion, '2.17.0')

  // Purge only failures. A status sync should only trigger when we know that the device counts are
  // "balanced". In that case, we will use the purge to help determine state. Anything that is NOT
  // FOUND or returns as a decline is clearly a decline, since we have cleared ONLY declines.
  /// Anything else is a success.
  if (purgeableAndroidVersion && enableClearSafDeclines()) executePerformMaintenance()

  yield put(setShouldStopSync())
  yield put(setSafStatusProgress(0))
  yield put(setSafStatusRequesting(false))
}

function* handleSyncSuccessRedirect(order, kioskDirectTo, isKiosk) {
  if (kioskDirectTo && isKiosk) {
    yield call(kioskDirectTo, `/kiosk/order/summary/${order?.uuid}`)
  } else {
    if (isQRPay(order)) {
      ToastManager.success('Scan QR code successful')
    }

    yield put(setRouteAction(`/receipt/${order?.uuid}`))
  }
}

function* handleSyncFailedRedirect(order, kioskDirectTo, isKiosk, isQrPay) {
  if (kioskDirectTo && isKiosk) {
    yield call(kioskDirectTo, '/kiosk/order/new')
  } else {
    ToastManager.error(`Order ${order?.orderNumber} failed to sync successfully`, { autoClose: false })
    if (isQrPay) return
    yield put(resetCFD())
    yield call(directTo, 'push', `/concession-order`)
  }
}

// Create orders in stadium. Payment is completed (online approval or paid with cash).
export function* syncOrder(params = {}) {
  const redirect = params?.redirect ?? false
  const printAuth = params?.printAuth ?? false
  const kioskDirectTo = params?.kioskDirectTo ?? (() => {})
  const displayOrderToast = params?.displayOrderToast
  const isKiosk = yield select(getIsKiosk)
  const kioskOfflineEnabled = getKioskOfflineEnabled({ fromAttractLoop: false })

  // Was this order offline and is now syncing to the platform. wasCreatedInStadium isn't a
  // measure of this for the initial sync since it hasn't yet been created in Stadium.
  const offlineOrder = params?.offlineOrder
  const fromSyncOrders = params?.fromSyncOrders

  // Suppress toasts (success and print) based when orders are being synced
  const ordersAreSyncing = yield select(getIsSyncing)
  const supressToasts = fromSyncOrders || ordersAreSyncing

  const isBackBar = yield select(getBackbarMode)

  let order = yield select((state) => getOrder(state, params.id))

  if (!order || order.isPreOrder || order.unsyncable) return

  const userUuid = yield select(getUserUuidFromOrderInProgress)

  // prevent changes to completed Rich Chekout orders
  if (isRichCheckout(order) && order.state === STADIUM_ORDER_STATES.COMPLETED) {
    yield put(syncOrderSucceeded({}, order))
    return
  }

  // close auth tab for
  // 1. start with auth, closed with same auth'd card
  // 2. start with auth, closed with a different payment
  // 3. BackBack completed orders
  // 4. Offline orders that were closed with a different payment
  // 5. orders that are being sync'ed and were not previously closed already
  // non-affiliations discounted orders
  // TODO: remove fixed custom tender from check once T40861 is implemented
  if (
    (order.state === STADIUM_ORDER_STATES.COMPLETION_PENDING ||
      getCreateOrderParams(order)?.state === STADIUM_ORDER_STATES.COMPLETED) &&
    !order.affiliations?.length &&
    order.isTab &&
    !isQRPay(order) &&
    !order.isClosedTab
  ) {
    yield put(closeTabOrder({ order, redirect, supressToasts }))
    return
  }

  // close auth tab for
  // 1. start with auth, closed with QR Pay
  // TODO [T35338]: use closeTabOrder above once T35336 is implemented
  if (
    order.neededToBeVoidedAuthPayment &&
    order.state === STADIUM_ORDER_STATES.COMPLETED &&
    order.wasCreatedInStadium &&
    isQRPay(order)
  ) {
    // distribute tip to payments
    const paymentsWithTips = distributeTipAmount(order.tipAmountInCents, order?.payments || [])

    try {
      // attempt to close to QR Pay
      const updateParams = ensureRelatedInvoiceNumbers({ ...order, payments: paymentsWithTips })
      const result = yield call(StadiumRemote.updatePosOrder, order.uuid, updateParams)

      if (result.data?.state === STADIUM_ORDER_STATES.AUTHORIZATION_FAILED) {
        const failedOrder = {
          ...order,
          state: STADIUM_ORDER_STATES.AUTHORIZATION_FAILED,
        }

        yield put(setQRPayAuthError(true))
        yield put(updateOrderFailed(order.uuid, failedOrder))
        yield call(handleSyncFailedRedirect, order, false, false)
        return
      }
      const removeFromOfflineCards = !hasOfflineCardTransactions(order)
      yield put(updateOrderSucceeded(result, order.uuid, { removeFromOfflineCards }))
    } catch (err) {
      yield put(updateOrderFailed(order.uuid, {}))
      yield call(handleSyncFailedRedirect, order, false, false)
    }

    if (redirect) {
      yield put(setRouteAction(`/receipt/${order?.uuid}`))
    }
    return
  }

  const usbPrintingEnabled = yield select(getUsbPrintingEnabled)
  const employeeId = getCreateOrderParams(order)?.employeeId || (yield verifyCurrentAttendant(isKiosk))
  if (employeeId === undefined) return

  let syncedOrder = {
    ...order,
  }

  // By the time the flow has gotten here, the assumption is we are online for Kiosk.
  const networkOnline = getNetworkAvailableValue()
  const isCashPayment = syncedOrder?.payments?.[0]?.paymentType === PAYMENT_TYPES.CASH

  if (!isKiosk && !networkOnline) {
    yield put(syncOrderFailed({ message: 'This device was offline while trying to sync.' }, syncedOrder))

    // offline BackBar "Pay Now" print auth receipt
    if (printAuth) {
      // if we are offline, and cloud printing, we need to bubble up a modal
      if (!usbPrintingEnabled) {
        yield put(SetOfflineDialog(true, APPLICATION_STRINGS.NETWORK_PRINTING_SLIP_OFFLINE_ERROR))
        return
      }

      // should not print if cash
      if (isCashPayment) return

      yield put(
        printOrder({
          orderUuid: order.uuid,
          printType: PRINT_TYPES.RECEIPT_AUTH,
        }),
      )
    }

    // take user to orders screen if pay now order
    // that is offline
    if (isBackBar) {
      yield put(clearPromotionsOnOrder())
      yield put(clearOrderInProgress())
      yield put(clearCart())

      // offline cash presents receipt screen
      if (isCashPayment) {
        yield put(setRouteAction(`/receipt/${order.uuid}`))
        return
      }

      yield put(setRouteAction('/orders'))
      return
    }

    // offline with redirect flag goes to receipt screen
    if (redirect && order.orderState === INTERNAL_ORDER_STATES.CLOSED) {
      yield put(setRouteAction(`/receipt/${order.uuid}`))
    }

    return
  }

  const isKioskQRFailedOrder = isKiosk && order.previousAuthorizationFailedStatus
  // Order was created in stadium with another state (e.g. submitted, tabbed)
  if (order.wasCreatedInStadium && !isKioskQRFailedOrder) {
    try {
      let createOrderParams = getCreateOrderParams(order)

      if (
        order.orderState === INTERNAL_ORDER_STATES.CLOSED &&
        (order.state !== STADIUM_ORDER_STATES.TABBED_OFFLINE ||
          getCreateOrderParams(order)?.state !== STADIUM_ORDER_STATES.TABBED_OFFLINE)
      ) {
        createOrderParams.state = STADIUM_ORDER_STATES.COMPLETED
        order.state = STADIUM_ORDER_STATES.COMPLETED
      }

      if (order.orderState === INTERNAL_ORDER_STATES.CANCELLED) {
        // Orders should not transition from completed to cancelled
        if (getCreateOrderParams(order)?.state === STADIUM_ORDER_STATES.COMPLETED) return

        createOrderParams.state = STADIUM_ORDER_STATES.CANCELLED
        order.state = STADIUM_ORDER_STATES.CANCELLED
      }

      if (order.orderState === INTERNAL_ORDER_STATES.FAILED) {
        createOrderParams.state = STADIUM_ORDER_STATES.AUTHORIZATION_FAILED
        order.state = STADIUM_ORDER_STATES.AUTHORIZATION_FAILED
      }

      // for Kiosk orders, QR Pay order should not get re-synced
      if (
        isKiosk &&
        fromSyncOrders &&
        order.state === STADIUM_ORDER_STATES.AUTHORIZATION_FAILED &&
        order.payments?.[0].paymentType === PAYMENT_TYPES.QR_PAY
      ) {
        yield put(updateOrderSucceeded(order, order.uuid))
        return
      }

      const isScannedTender = orderIsScannedTender(order)
      const orderHasOfflineCardTransactions = hasOfflineCardTransactions(order)
      if (isScannedTender && orderHasOfflineCardTransactions) {
        const orderPayments = order?.payments || getCreateOrderParams(order)?.payments
        const paymentsWithTips = distributeTipAmount(order.tipAmountInCents, orderPayments)

        createOrderParams.payments = paymentsWithTips
      }

      const updateParams = ensureRelatedInvoiceNumbers(createOrderParams)
      const result = yield call(StadiumRemote.updatePosOrder, order.uuid, updateParams, isKiosk)

      //Check for QR pay auth error and set flag to true
      if (
        (result.data?.state === STADIUM_ORDER_STATES.SETTLEMENT_FAILED ||
          result.data?.state === STADIUM_ORDER_STATES.AUTHORIZATION_FAILED) &&
        order.payments?.[0].paymentType === PAYMENT_TYPES.QR_PAY
      ) {
        const updatedOrder = updateNextSync(order)

        yield put(syncOrderFailed(result, updatedOrder))
        yield put(setQRPayAuthError(true))

        return
      }

      // updated tab may have a different payment id (UUID) - needed for using order_mutations
      if (order.isTab) {
        const resultingOrder = {
          ...order,
          payments: (order?.payments || []).map((localPayment) => ({
            ...localPayment,
            paymentId:
              result.data?.paymentInfo?.find((resultPayment) => isSamePayment(localPayment, resultPayment))?.uuid ||
              localPayment.paymentId,
          })),
        }
        yield put(saveOrder(resultingOrder, false))
      }
      const removeFromOfflineCards = !hasOfflineCardTransactions(createOrderParams)

      const remotePayments = result?.data?.paymentInfo ?? []

      const updatedPayments = (order.payments || []).map((payment) => mapUpdatedPaymentUuidFromResponse(remotePayments, payment))

      yield put(updateOrderSucceeded(result, order.uuid, { removeFromOfflineCards, updatedPayments }))

      // [T35551] Non-cash backBar stays open
      const isCashPayment = order.payments?.length === 1 && order.payments?.[0].paymentType === PAYMENT_TYPES.CASH
      const isCompleted = getCreateOrderParams(order)?.state === STADIUM_ORDER_STATES.COMPLETED
      if (isBackBar && redirect && !isCashPayment && !isCompleted) {
        yield put(
          printOrder({
            orderUuid: order?.uuid,
            printType: PRINT_TYPES.RECEIPT_AUTH,
          }),
        )
        yield put(clearPromotionsOnOrder())
        yield put(clearOrderInProgress())
        yield put(clearCart())

        yield put(setRouteAction('/orders'))
        return
      }

      if (!order?.neededToBeVoidedAuthPayment && order.isTab) {
        if (order.state !== STADIUM_ORDER_STATES.TABBED && !supressToasts) {
          ToastManager.success(APPLICATION_STRINGS.CLOSE_TAB_SUCCEEDED)
        }
        yield put(clearCart())
        yield put(clearOrderInProgress())
      }

      if (redirect) {
        yield call(handleSyncSuccessRedirect, order, kioskDirectTo, isKiosk)
      }
      return
    } catch (err) {
      const applicationMessage = err?.response?.data?.errorMessage
      const friendlyMessage = err?.response?.data?.friendlyMessage
      const errorMessage = friendlyMessage ?? applicationMessage

      // when updating from an error, only update syncAttempts property
      const { syncAttempts } = updateNextSync(order)
      yield put(updateOrderFailed(order.uuid, { syncAttempts }, err, true))
      if (errorMessage && err?.message !== 'Network Error' && (!supressToasts || (supressToasts && !isPrintError(err)))) {
        ToastManager.error(`${errorMessage}`, { autoClose: false })
        createDataDogLog('error', errorMessage)
      }
      if (redirect) {
        yield call(handleSyncFailedRedirect, order, kioskDirectTo, isKiosk, isQRPay(order))
      }
    }

    if (order.orderState !== INTERNAL_ORDER_STATES.CLOSED) {
      return
    }
  }

  //if the order has no items at this point, the order is unsyncable and this process should be aborted
  if (isEmpty(getCreateOrderParams(order)?.orderMenuItems)) {
    order.unsyncable = true
    if (redirect) {
      yield call(handleSyncFailedRedirect, order, kioskDirectTo, isKiosk)
    } else {
      yield put(syncOrderFailed({ message: 'This order has no line items.' }, order))
    }
  }

  try {
    /**
     * Since platform for a kiosk order that already had a payment wont let us update it
     * we need to clone the existing order with new IDs in order for the POST endpoint can
     * create a new order with the new payment type. Right now the PUT endpoint for Kiosk orders
     * is not updating the payment for an order which already has a QR payment applied.
     */
    if (isKioskQRFailedOrder) {
      //Generate new ID's
      const oldOrderId = order.uuid
      const newOrderId = generateUuid()

      //We need to increment the order for the new order
      const newOrderNumber = nextPosOrderNumber()

      //create new order
      yield put(duplicateOrderWithNewIds({ oldOrderId, newOrderId, newOrderNumber }))

      //restore failed values to old order
      yield put(restoreQRPaymentandAuthorizationFailedStatus(oldOrderId))

      const newOrder = yield select((state) => getOrder(state, newOrderId))

      order = newOrder
      syncedOrder = { ...order }

      yield call(incrementNextOrderNumber)
    }

    // completed tab with scan tender and another non-credit payment
    const nonCreditScanTenderPayments = order.balanceDueInCents === 0 && isScannedTenderNonCC(order.payments)
    // TODO(mkramerl): Use a more sophisticated method of detecting whether this was a tabbed order
    // that never made it to the core service.
    // If this was an already completed order that never made it to the core service, and it was
    // known to be a tabbed order, we need to create it in the core service in a tabbed state first.
    // After the order is created in a tabbed state, we save, exit, and restart the sync order process
    // so that the order can be updated via PUT request.
    const tabState = isOfflineApproval(order) ? STADIUM_ORDER_STATES.TABBED_OFFLINE : STADIUM_ORDER_STATES.TABBED
    if (
      !order.wasCreatedInStadium &&
      order.state === STADIUM_ORDER_STATES.COMPLETED &&
      order.tabName !== null &&
      order.tabName !== undefined
    ) {
      const createParams = ensureRelatedInvoiceNumbers({
        ...getCreateOrderParams(order),
        state: nonCreditScanTenderPayments ? order.state : tabState,
        employeeId,
        userUuid: order?.userUuid ?? userUuid,
      })

      yield call(StadiumRemote.createPosOrder, createParams, isKiosk)
      yield put(saveOrder(ensureRelatedInvoiceNumbers({ ...order, wasCreatedInStadium: true })))
      if (nonCreditScanTenderPayments) {
        yield put(syncOrderSucceeded(null, order))
        if (redirect) {
          yield put(setRouteAction(`/receipt/${order?.uuid}`))
        }
        yield put(clearPromotionsOnOrder())
        yield put(clearOrderInProgress())
        yield put(clearCart())
        return
      }
      yield put(syncOrderRequested({ orderUuid: order.uuid, redirect: redirect, kioskDirectTo: kioskDirectTo }))
      return
    }

    // PPI
    yield put(setPreOrderPayments(order.uuid, getCreateOrderParams(order).payments))

    const orderParams = { ...getCreateOrderParams(order) }

    // populate invoice number in submitted order
    const curInvoiceNumber = order.userAttributes?.freedompayInvoiceNumber
    const firstPayment = orderParams.payments?.[0]
    if (
      orderParams.state === STADIUM_ORDER_STATES.SUBMITTED &&
      curInvoiceNumber &&
      !firstPayment?.userAttributes?.freedompayInvoiceNumber
    ) {
      if (isCreditType(firstPayment?.paymentType)) {
        orderParams.payments[0].userAttributes = {
          ...firstPayment.userAttributes,
          freedompayInvoiceNumber: curInvoiceNumber,
          href: curInvoiceNumber,
        }
      }
    }

    // canceled tab with offline auth
    const hasOfflineApproval = order?.payments?.some((payment) => payment.userAttributes?.isOfflineApproval)
    if (order.isTab && orderParams.state === STADIUM_ORDER_STATES.CANCELLED && hasOfflineApproval) {
      orderParams.state = STADIUM_ORDER_STATES.COMPLETION_PENDING
    }

    //When creating an order, if the order has been completed, send in undefined to allow the platform to
    //properly process the correct completion state of the order.
    const state = orderParams.state === STADIUM_ORDER_STATES.COMPLETED ? undefined : orderParams.state

    const createParams = ensureRelatedInvoiceNumbers({
      ...orderParams,
      // An offline order now syncing has no chance of having promotions nor affiliations applied since that needs to be done online.
      promotions: offlineOrder ? [] : undefined,
      affiliations: offlineOrder ? [] : undefined,
      employeeId,
      userUuid: order?.userUuid ?? userUuid,
      state,
    })

    const result = yield call(StadiumRemote.createPosOrder, createParams, isKiosk)

    // online
    // when BackBar "Pay Now" print auth receipt
    if (result?.data?.applied && printAuth) {
      yield put(
        printOrder({
          orderUuid: order.uuid,
          printType: PRINT_TYPES.RECEIPT_AUTH,
        }),
      )
      yield put(clearPromotionsOnOrder())
      yield put(clearOrderInProgress())
      yield put(clearCart())
      yield put(saveOrder({ ...order, wasCreatedInStadium: true }))
      yield put(syncOrderSucceeded(result, order))

      yield put(setRouteAction('/orders'))
      return
    }

    const kitchenPrintingEnabled = yield select((state) => getKitchenPrintingEnabled(state))

    // If the order is in pre-auth don't show the order toast.
    if (
      displayOrderToast &&
      !supressToasts &&
      order.orderState !== INTERNAL_ORDER_STATES.PREAUTH &&
      order.orderState !== INTERNAL_ORDER_STATES.FAILED &&
      order.state !== STADIUM_ORDER_STATES.CANCELLED &&
      getCreateOrderParams(order)?.state !== STADIUM_ORDER_STATES.CANCELLED
    ) {
      presentOrderToast(kitchenPrintingEnabled, result)
    }

    // PPI
    if (result?.data?.order) {
      yield put(setOrderPayments(result.data.order.uuid, result.data.order.paymentTransactions))
    }

    // tab with payments - need to map payment uuids
    if (order.isTab && order.payments?.length > 0) {
      // map the resulting payment uuids back to local state
      const result = yield call(StadiumRemote.getOrderDetails, order.uuid)
      const remotePayments = result?.data?.paymentInfo ?? []

      const updatedPayments = (order.payments || []).map((payment) => mapUpdatedPaymentUuidFromResponse(remotePayments, payment))
      const updatedAuths = (order.neededToBeVoidedAuthPayment || []).map((payment) =>
        mapUpdatedPaymentUuidFromResponse(remotePayments, payment),
      )

      yield put(
        syncOrderSucceeded(result, {
          ...order,
          payments: updatedPayments,
          neededToBeVoidedAuthPayment: updatedAuths?.length ? updatedAuths : null,
          wasCreatedInStadium: true,
        }),
      )

      return
    }

    const latestOrder = yield select((state) => getOrder(state, order.uuid))
    syncedOrder = { ...latestOrder }

    if (redirect) {
      yield call(handleSyncSuccessRedirect, order, kioskDirectTo, isKiosk)
    }

    const isScannedTender = orderIsScannedTender(order)
    const orderHasOfflineCardTransactions = hasOfflineCardTransactions(order)

    if (isKiosk && isScannedTender && orderHasOfflineCardTransactions) {
      const remotePayments = result?.data?.paymentInfo ?? []
      const updatedPayments = (syncedOrder.payments || []).map((payment) =>
        mapUpdatedPaymentUuidFromResponse(remotePayments, payment),
      )

      syncedOrder.payments = updatedPayments
    }

    yield put(syncOrderSucceeded(result, syncedOrder))

    // for ticket, QR Pay and Gift Card: when order is in pre-auth, at
    // this point, if there is a matching orderInProgressLoaded,
    // it must be flagged as wasCreatedInStadium to avoid double creation of order
    if (syncedOrder.orderState === INTERNAL_ORDER_STATES.PREAUTH) {
      const orderInProgress = yield select(getOrderInProgress)
      if (orderInProgress?.uuid === syncedOrder.uuid && !orderInProgress.wasCreatedInStadium) {
        //Only update wasCreatedInStadium instead of the whole order
        yield put(updateOrderInProgress({ wasCreatedInStadium: true }))
      }
    }
  } catch (err) {
    const applicationMessage = err?.response?.data?.errorMessage ?? ''

    // check if QR Pay timed out
    const isQRPayTimeout = isQRPay(order) && (err?.response?.status === 408 || err?.code === 'ECONNABORTED')

    const QRPayFailedTransaction =
      applicationMessage?.includes('Nonce charge failed.') ||
      applicationMessage?.includes('Wallet charge failed.') ||
      isQRPayTimeout

    if (applicationMessage?.includes('You must login to create orders!')) {
      yield call(directTo, 'push', '/user-login')
      ToastManager.error(APPLICATION_STRINGS.PLEASE_LOGIN, { autoClose: false })
      createDataDogLog('error', APPLICATION_STRINGS.PLEASE_LOGIN)
    }

    const friendlyMessage = err?.response?.data?.friendlyMessage
    const errorMessage = friendlyMessage ?? applicationMessage

    if (QRPayFailedTransaction) {
      syncedOrder.wasCreatedInStadium = true
    }

    syncedOrder = updateNextSync(syncedOrder)
    yield put(syncOrderFailed(err, syncedOrder))

    if (errorMessage && err?.message !== 'Network Error' && !QRPayFailedTransaction) {
      // Only show error toast if supressToasts is false,
      // or if supressToasts is true but the error is not a print error
      if (!supressToasts || (supressToasts && !isPrintError(err))) {
        ToastManager.error(`${errorMessage}`, { autoClose: false })
        createDataDogLog('error', errorMessage)
      } else {
        alert(applicationMessage)
      }
    }

    /**
     * if we have a transaction declined from QRPay we want to stay in the same screen and let
     * the user apply another payment, then we need to stop the redirect to the menu from happening
     */
    if (QRPayFailedTransaction) {
      yield put(setQRPayAuthError(true))
      yield put(setOrderInProgressWithId(order.uuid))
      return
    }

    if (isKiosk && !order.wasCreatedInStadium && kioskOfflineEnabled) {
      yield call(kioskDirectTo, `/kiosk/order/summary/${order?.uuid}`)
      return
    }

    if (redirect) {
      yield call(handleSyncFailedRedirect, order, kioskDirectTo, isKiosk, isQRPay(order))
    }
  }
}

// Create order in stadium if payment is approved offline, or if the initial create request failed.
// Update order in stadium if payment was approved offline and is now finished (either failed or
// approved from card reader)
// For updates, we need to make sure the order is first created in Stadium so we have an
// offline_approval state transition
export function* syncOfflineOrder(params = {}) {
  const order = yield select((state) => getOrder(state, params.id))

  if (!getNetworkAvailableValue()) {
    yield put(updateOrderFailed(order.uuid, order, null, true))
    return
  }

  if (isTabbed(order)) return
  if (!order || order.unsyncable) return

  const isKiosk = yield select((state) => getIsKiosk(state))

  // Order was created in stadium with offline_approval state; need to update it
  if (order.wasCreatedInStadium) {
    try {
      const updateParams = ensureRelatedInvoiceNumbers(getCreateOrderParams(order))
      const result = yield call(StadiumRemote.updatePosOrder, order.uuid, updateParams, isKiosk)
      const removeFromOfflineCards = !hasOfflineCardTransactions(order)
      yield put(updateOrderSucceeded(result, order.uuid, { removeFromOfflineCards }))
    } catch (err) {
      const applicationMessage = err?.response?.data?.errorMessage
      const friendlyMessage = err?.response?.data?.friendlyMessage
      const errorMessage = friendlyMessage ?? applicationMessage

      // when updating from an error, only update syncAttempts property
      const { syncAttempts } = updateNextSync(order)
      yield put(updateOrderFailed(order.uuid, { syncAttempts }, err, true))

      if (errorMessage && err?.message !== 'Network Error') {
        ToastManager.error(`${errorMessage}`, { autoClose: false })
        createDataDogLog('error', errorMessage)
      }
    }

    return
  }

  // If the order was not created in stadium, we need to create it; otherwise, this is a second
  // attempt at creation and should be ignored.
  if (order.wasCreatedInStadium) return
  const finished = isFinalState(getCreateOrderParams(order).state)
  if (finished) return

  // Only verify the employee if this is actually a create action.
  const employeeId = getCreateOrderParams(order)?.employeeId || (yield verifyCurrentAttendant(isKiosk))
  if (employeeId === undefined) return

  // PPI
  yield put(setPreOrderPayments(order.uuid, getCreateOrderParams(order).payments))

  try {
    const createParams = ensureRelatedInvoiceNumbers({
      ...getCreateOrderParams(order),
      employeeId,
      state: STADIUM_ORDER_STATES.APPROVED_OFFLINE,
    })

    const result = yield call(StadiumRemote.createPosOrder, createParams, isKiosk)
    const kitchenPrintingEnabled = yield select((state) => getKitchenPrintingEnabled(state))
    presentOrderToast(kitchenPrintingEnabled, result)

    // PPI
    if (result?.data?.order) {
      yield put(setOrderPayments(result.data.order.uuid, result.data.order.paymentTransactions))
    }

    yield put(createOfflineOrderSucceeded(result, order.uuid))
  } catch (err) {
    const applicationMessage = err?.response?.data?.errorMessage ?? ''

    if (applicationMessage?.includes('You must login to create orders!')) {
      yield call(directTo, 'push', '/user-login')
      ToastManager.error(APPLICATION_STRINGS.PLEASE_LOGIN, { autoClose: false })
      createDataDogLog('error', APPLICATION_STRINGS.PLEASE_LOGIN)
    }

    const friendlyMessage = err?.response?.data?.friendlyMessage
    const errorMessage = friendlyMessage ?? applicationMessage
    const updatedOrder = updateNextSync(order)

    yield put(createOfflineOrderFailed(order.uuid, updatedOrder, err))

    if (errorMessage && err?.message !== 'Network Error') {
      ToastManager.error(`${errorMessage}`, { autoClose: false })
      createDataDogLog('error', errorMessage)
    }
  }
}

export function* _saveRichCheckoutOrder(params = {}) {
  const isKiosk = get(params, 'payload.isKiosk', false)
  const redirect = get(params, 'payload.redirect', false)
  const employeeId = yield verifyCurrentAttendant(isKiosk)
  if (employeeId === undefined) return

  const useNormalTaxRounding = yield select(getUseNormalTaxRounding)
  const taxClasses = yield select(getTaxClasses)
  const taxRules = yield select(getTaxRules)
  const useTaxClasses = yield select(getUseTaxClasses)
  const taxExempt = yield select(getIsOrderTaxExempt)
  const taxExemptData = yield select(getTaxExemptData)
  const taxExemptReason = taxExemptData?.reason || ''
  const taxExemptApproverUuid = yield select(getTaxExemptApproverUuid)

  const uuid = yield select((state) => getOrderSubumissionUuid(state, params?.payload.uuid))
  const orderNumber = get(params, 'payload.orderNumber', nextPosOrderNumber())

  const { menuUuid, revenueCenterUuid, revenueName } = yield menuAndRvcUuids(isKiosk)

  const lineItems = yield select(getCartItems)
  let userNotes = yield select(getCartNotes)
  const orderNotes = yield select(getOrderNotes)

  if (orderNotes) {
    userNotes = userNotes ? `${userNotes?.split('\nNote:')[0]}\n${orderNotes}` : `\n${orderNotes}`
  }

  const itemModels = makeLineItemData(lineItems)

  const taxRate = yield select(getTaxRate)
  const taxByItem = yield select(getTaxByItem)

  const remoteOrderTotal = yield select(getRemoteOrderTotal)
  const discountAmountInCents = remoteOrderTotal?.discountAmountInCents ?? 0

  let taxAmountInCents
  let calculateTaxResult
  let taxRulesBreakdown = {}

  if (remoteOrderTotal?.isAvailable) {
    taxAmountInCents = remoteOrderTotal?.taxAmountInCents ?? 0
    taxRulesBreakdown = remoteOrderTotal?.taxRulesBreakdown || {}
  } else {
    calculateTaxResult = calculateTax(
      lineItems,
      taxRate,
      taxByItem,
      useNormalTaxRounding,
      useTaxClasses,
      taxClasses,
      taxRules,
      taxExempt,
    )
    taxAmountInCents = calculateTaxResult.taxAmountInCents
    taxRulesBreakdown = calculateTaxResult?.taxRulesBreakdown || {}
  }

  let subtotalAmountInCents = remoteOrderTotal?.subtotalInCents ?? calculateSubtotal(lineItems)
  let amountInCents = remoteOrderTotal?.totalAmountInCents ?? subtotalAmountInCents + taxAmountInCents
  let serviceFee = { name: 'Service Charge', total: 0, legal: null }

  // Recalibrate the subtotal and total based on whether or not there is a remote total.
  if (!isNil(remoteOrderTotal?.totalAmountInCents)) {
    // When there is a remote total, the subtotal is present and properly calculated.
    serviceFee = {
      name: remoteOrderTotal?.serviceChargeName,
      total: remoteOrderTotal?.serviceChargeInCents ?? 0,
      legal: remoteOrderTotal.serviceChargeLegal,
    }
  } else {
    // When there is no remote total, the service fee needs to be calculated and added into the
    // total but not the subtotal.
    const serviceCharge = yield select((state) => getMenuServiceCharge(state))
    serviceFee = {
      name: serviceCharge.name,
      total: calculateServiceCharge(serviceCharge, subtotalAmountInCents) ?? 0,
      legal: serviceCharge.legal,
      taxClassUuid: serviceCharge?.taxClassUuid,
    }

    let serviceFeeTaxAmountInCents = 0

    if (useTaxClasses) {
      const calculateServiceFeeTaxRulesResult = calculateServiceFeeTaxRules(
        taxRulesBreakdown,
        serviceFee,
        useNormalTaxRounding,
        taxClasses,
        taxRules,
        taxExempt,
      )
      serviceFeeTaxAmountInCents = calculateServiceFeeTaxRulesResult.serviceFeeTaxAmountInCents
      taxRulesBreakdown = calculateServiceFeeTaxRulesResult.taxRulesBreakdown || {}
    } else {
      serviceFeeTaxAmountInCents = calculateIndividualTaxAmount(
        taxRate,
        serviceFee.total,
        serviceCharge.taxable,
        useNormalTaxRounding,
      )
    }

    taxAmountInCents += serviceFeeTaxAmountInCents
    amountInCents = amountInCents + serviceFee.total + serviceFeeTaxAmountInCents
  }

  const affiliations = remoteOrderTotal?.isAvailable ? [] : null
  let promotions = yield select(getSelectedPromotions)
  if (isEmpty(promotions) || !remoteOrderTotal.isAvailable) {
    promotions = undefined
  }

  const createOrderParams = {
    ...makeCreateOrderParams({
      amountInCents,
      employeeId,
      itemModels,
      menuUuid,
      orderNumber,
      paymentType: 'mobile_app',
      submittedAt: new Date(),
      uuid,
      affiliations,
      promotions,
      userNotes,
    }),
  }

  const orderData = {
    ...createOrderParams,
    amountInCents,
    subtotalAmountInCents,
    discountAmountInCents,
    taxAmountInCents,
    balanceDueInCents: 0,
    serviceFee,
    itemModels,
    orderNumber,
    paymentCompleted: true,
    revenueCenterUuid,
    revenueName,
    submittedAt: new Date(),
    uuid,
    userNotes,
    taxRulesBreakdown,
    taxExempt,
    taxExemptReason,
    taxExemptApproverUuid: taxExempt ? taxExemptApproverUuid : '',
  }

  yield put(saveRichCheckoutOrder(orderData))
  yield put(clearRemoteOrderTotal())

  if (redirect) {
    yield put(setRouteAction(`/receipt/${uuid}`))
  }
}

/**
 * Handles the printing and redirection after a BackBar order is printed
 *
 * @param {String} orderId
 * @param {Boolean} isCashPayment
 * @returns {Void}
 */
function* backBarPrintAndRedirectSaga(orderId, isCashPayment) {
  yield put(clearCart())
  yield put(clearOrderInProgress())
  yield put(clearPromotionsOnOrder())

  // cash payment does not auto print
  if (isCashPayment) {
    yield put(setRouteAction(`/receipt/${orderId}`))
    return
  }

  // print auth slip and redirect to orders screen
  yield put(
    printOrder({
      orderUuid: orderId,
      printType: PRINT_TYPES.RECEIPT_AUTH,
    }),
  )

  yield put(setRouteAction('/orders'))
}

/**
 * When dealing with BackBar orders, "print slip" requires replacing the payment and printing auth slip
 *
 * @param {Object} order - Current Order State
 * @param {Object} orderUpdate - Order update object
 * @param {Object} newPayment - New payment object to be added
 */
function* printSlipSaga(order, orderUpdate, newPayment) {
  const orderId = order.uuid
  let replacePayments = !!order?.payments?.[0]?.paymentId
  const wasCreatedInStadium = order.wasCreatedInStadium || orderUpdate.wasCreatedInStadium
  const isCashPayment = newPayment?.paymentType === PAYMENT_TYPES.CASH
  const cashRounded = orderUpdate?.cashRounded ?? false
  const isNetworkAvailable = getNetworkAvailableValue()
  const isCardPaymentOffline = newPayment.userAttributes?.isOfflineApproval || false
  const paymentPayload = {
    ...newPayment,
    userAttributes: {
      ...newPayment.userAttributes,
      isBackBar: true,
      preservePaymentAfterReopen: true, // preserve payment after reopen
    },
  }

  // mark tabbed order to offline if the payment is approved offline
  const updatedState = isCardPaymentOffline && isTabbed(order) ? STADIUM_ORDER_STATES.TABBED_OFFLINE : order.state

  // if we are offline, we need to preserve the payment after reopen
  if (!isNetworkAvailable) {
    const payload = {
      ...order,
      ...orderUpdate,
      payments: [paymentPayload],
      isMultiPayment: false,
      state: updatedState,
    }

    if (isCashPayment) {
      payload.state = STADIUM_ORDER_STATES.COMPLETED
    }

    yield put(saveOrder(ensureRelatedInvoiceNumbers(payload), true, false, isCardPaymentOffline))
    yield call(backBarPrintAndRedirectSaga, orderId, isCashPayment)
    return
  }

  try {
    // if the order was not created in stadium, we need to create it
    if (!wasCreatedInStadium) {
      const payload = ensureRelatedInvoiceNumbers({
        ...order,
        ...orderUpdate,
        state: updatedState,
        // when creating in stadium, include any auth payments first to be voided later
        payments: orderUpdate.neededToBeVoidedAuthPayment || [paymentPayload],
      })

      yield call(StadiumRemote.createPosOrder, payload)

      // if there was an auth payment to be voided, retrieve the payment ID from stadium
      if (orderUpdate.neededToBeVoidedAuthPayment) {
        const resultingOrder = yield call(StadiumRemote.getOrderDetails, order.uuid)
        payload.payments = resultingOrder?.data?.paymentInfo || []

        // since order with original offline auth is now created in stadium, we will be replacing it with new payments
        replacePayments = true
        payload.neededToBeVoidedAuthPayment = (payload.neededToBeVoidedAuthPayment || []).map((localPayment) => ({
          ...localPayment,
          isVoided: true,
          paymentId:
            resultingOrder.data?.paymentInfo?.find((resultPayment) => isSamePayment(localPayment, resultPayment))?.uuid ||
            localPayment.paymentId,
        }))
      }

      yield put(saveOrder({ ...payload, wasCreatedInStadium: true, needsSync: false }, true, false, isCardPaymentOffline))
    }

    // replace payment with new payment in single operation
    const payload = { orderId, payments: [paymentPayload], replacePayments, cashRounded }
    const result = yield call(MutationApi.addPayment, payload)
    const applied = result?.data?.orderMutations?.[0]?.applied
    if (!applied) {
      throw new Error('Failed to add payment to tab')
    }
    if (isCashPayment) {
      const closeResult = yield call(MutationApi.closeTabOrder, { orderId, cashRounded })
      if (!closeResult?.data?.orderMutations?.[0]?.applied) {
        throw new Error('Failed to close tab')
      }
    }

    yield call(getOrderDetails, { payload: { orderUuid: orderId } })
    yield call(backBarPrintAndRedirectSaga, orderId, isCashPayment)
  } catch (e) {
    // voiding failed, proceed with add payment
    createDataDogLog('error', '[BackBar]' + (e.message || 'Failed to void BackBar auth'), { orderUuid: orderId })

    ToastManager.error(APPLICATION_STRINGS.UPDATE_PAYMENT_FAILED, { autoClose: false })
    yield put(clearCart())
    yield put(clearOrderInProgress())
    yield put(clearPromotionsOnOrder())
    yield put(setRouteAction('/orders'))
  }
}

export function* addPaymentToOrderInProgressSaga(params = {}) {
  const paymentId = params?.payload?.paymentId ?? ''
  const paymentType = params?.payload?.paymentType
  const cashRoundingInCents = params?.payload?.cashRoundingInCents ?? 0
  const tenderAmountInCents = +(params?.payload?.tenderAmountInCents ?? 0) + cashRoundingInCents
  const signature = params?.payload?.signature
  const charityAmountInCents = +(params?.payload?.charityAmountInCents ?? 0)
  const tipAmountInCents = parseInt(params?.payload?.tipAmountInCents ?? 0)
  const cardReaderData = params?.payload?.cardReaderData
  let shortDescription = params?.payload?.shortDescription
  const remainingTicketBalance = params?.payload?.remainingTicketBalance
  const isApprovedOffline = params?.payload?.isApprovedOffline
  const maximumAmount = params?.payload?.maximumAmount
  const token = params?.payload?.token
  const push = params?.payload?.push
  const navigateHistory = params?.payload?.navigateHistory ?? true
  const reopenSavedPayment = params?.payload?.reopenSavedPayment
  const isBackBar = yield select((state) => getBackbarMode(state))
  const currentPaymentFlow = yield select((state) => getCurrentPaymentFlow(state))
  const order = yield select((state) => getOrderInProgress(state))
  const existingOrder = yield select(getOrder, order.uuid)
  const deviceMode = yield select((state) => getDeviceMode(state))

  // if the order has an auth payment, reset the payments array to empty and store the auth'd payment to be voided later at close
  const isPreAuthTab = getIsPreAuthTab(order)
  const internalPaymentType = isPreAuthTab ? PAYMENT_TYPES_INTERNAL.SAVED_CARD : null
  let userAttributes = { isOverageCard: false }
  let userName

  if (maximumAmount) {
    userAttributes.isFixedCustomTender = true
  }

  if (cardReaderData) {
    userAttributes = makeUserAttributes(cardReaderData, internalPaymentType)
    userName = getUserNameFromCard(cardReaderData)
  }

  const originalAuthPayment = isPreAuthTab ? { ...order.payments?.[0], amountInCents: 0, tipAmountInCents: 0 } : null
  const moveAuthToNeededToBeVoided = isPreAuthTab && paymentType !== PAYMENT_TYPES_INTERNAL.QR_PAY
  const neededToBeVoidedAuthPayment =
    order.neededToBeVoidedAuthPayment || (moveAuthToNeededToBeVoided && [originalAuthPayment]) || null

  const orderPayments = isPreAuthTab ? [] : order.payments || []
  const newCardReaderData = () => {
    if (isBackBar) {
      return cardReaderData
    }

    if (isPreAuthTab) {
      return null
    }

    return order.cardReaderData
  }

  let balanceDueInCents = (order?.balanceDueInCents || order.total) - tenderAmountInCents + cashRoundingInCents

  // balance is alredy zero, need a "replace" payment order instead
  if (order?.balanceDueInCents === 0) {
    balanceDueInCents = 0
  }
  if (
    balanceDueInCents < 0 &&
    (tipAmountInCents === Math.abs(balanceDueInCents) || charityAmountInCents === Math.abs(balanceDueInCents))
  ) {
    // tips have not been added to balanceDueInCents
    balanceDueInCents = 0
  }

  const orderNumber = cardReaderData?.orderNumber ?? params?.payload?.orderNumber ?? nextPosOrderNumber()
  const orderUpdate = {
    balanceDueInCents,
    charityAmountInCents: (order?.charityAmountInCents ?? 0) + charityAmountInCents,
    tipAmountInCents: (order?.tipAmountInCents ?? 0) + tipAmountInCents,
    amountInCents: (order?.amountInCents ?? 0) + tipAmountInCents + charityAmountInCents + cashRoundingInCents,
    neededToBeVoidedAuthPayment,
    cardReaderData: newCardReaderData(),
    isBackBar,
  }

  //flag the order as cash rounded and add rounded amount if cash rounding is applied
  if (cashRoundingInCents !== 0) {
    orderUpdate.cashRoundingInCents = cashRoundingInCents
    orderUpdate.cashRounded = true
  }

  // preserve wasCreatedInStadium flag
  if (existingOrder?.wasCreatedInStadium) {
    orderUpdate.wasCreatedInStadium = true
  }

  if (isPreAuthTab) {
    orderUpdate.paymentAuthorizedAt = null
  }

  // Tab Name in BackBar defaults to orderNumber
  // use cardholderName when available
  if (isBackBar && !isNaN(+order.tabName) && cardReaderData?.cardholderName) {
    orderUpdate.userName = getUserNameFromCard(cardReaderData)
    orderUpdate.tabName = cardReaderData.cardholderName
  }

  let newPayment = {
    paymentId,
    paymentType,
    amountInCents: tenderAmountInCents + tipAmountInCents + charityAmountInCents,
    orderNumber,
    shortDescription,
    charityAmountInCents,
    tipAmountInCents,
    token,
    userAttributes,
  }

  if (paymentType === PAYMENT_TYPES.CREDIT_CARD || paymentType === PAYMENT_TYPES_INTERNAL.CREDIT_CARD) {
    newPayment.userName = userName
    newPayment.signature = signature
    newPayment.cardType = userAttributes.freedompayIssuerName
    newPayment.label = cardReaderData?.cardType
    newPayment.shortDescription = `${userAttributes?.freedompayIssuerName} ${userAttributes?.last_4}`
    orderUpdate.receiptSignature = signature
    orderUpdate.isApprovedOffline = isApprovedOffline
    orderUpdate.cardReaderData = cardReaderData
    orderUpdate.userAttributes = userAttributes

    if (!shortDescription) {
      shortDescription = newPayment.shortDescription
    }
  } else {
    orderUpdate.cardReaderData = null
    orderUpdate.paymentAuthorizedAt = null
    orderUpdate.userAttributes = null

    // orders that have a credit card payment should preserve user attributes
    if (hasCreditType(order.payments) && order.userAttributes) {
      orderUpdate.userAttributes = order.userAttributes
    }
  }

  if (paymentType === PAYMENT_TYPES.TICKET || paymentTypeIsPpi(paymentType)) {
    orderUpdate.remainingTicketBalance = remainingTicketBalance
  }

  if (paymentType === PAYMENT_TYPES.CASH && isOfflineApproval(order)) {
    orderUpdate.isApprovedOffline = true
  }

  if (paymentTypeIsPpi(paymentType) && params?.payload?.userAttributes) {
    newPayment.userAttributes = params.payload.userAttributes
  }

  if (params?.payload?.isRichCheckout) {
    orderUpdate.isRichCheckout = true
  }

  if (!reopenSavedPayment) {
    //tab orders from other devices will not have the payments array initialized, then we need to handle that scenario.
    orderUpdate.payments = [...orderPayments, newPayment]
  } else {
    orderUpdate.payments = [...orderPayments, reopenSavedPayment]
  }
  // Always keep the in-state order number in sync with the creation parameters. In the case that
  // the order hasn't been created, it can be assumed the current order number is the most accurate.
  orderUpdate.orderNumber = getCreateOrderParams(order)?.orderNumber ?? order?.orderNumber ?? orderNumber

  if (orderUpdate.payments.length > 1) {
    orderUpdate.isMultiPayment = true
    orderUpdate.displayName = 'Multiple Tenders'
  } else {
    orderUpdate.displayName = shortDescription
    orderUpdate.paymentDisplay = shortDescription
  }

  // Handle BackBar Print Auth Slip
  if (isBackBar) {
    yield call(printSlipSaga, order, orderUpdate, newPayment)
    return
  }

  // when authorization failed, we need to set state back to tabbed
  if (order.state === STADIUM_ORDER_STATES.AUTHORIZATION_FAILED) {
    if (order.isTab) {
      orderUpdate.state = STADIUM_ORDER_STATES.TABBED

      if (!order.wasCreatedInStadium) {
        orderUpdate.state = STADIUM_ORDER_STATES.TABBED_OFFLINE
      }
    }
  }

  yield put(updateOrderInProgress(orderUpdate))
  if (balanceDueInCents === 0) {
    yield call(syncAndSaveOrderInProgress, push)

    // doubling this up since this only seems to be needed with a CFD attached
    if (
      deviceMode === MODES.POS &&
      (currentPaymentFlow === CFD_POS_PAYMENT_FLOWS.SPLIT_PAY || currentPaymentFlow === CFD_POS_PAYMENT_FLOWS.AUTO_SPLIT) &&
      (!order.isTab || !isTabbed(order))
    ) {
      if (navigateHistory) {
        yield put(setRouteAction(`/receipt/split-tender/${paymentId}`))
        return
      }
    }
  } else if (paymentId) {
    if (!navigateHistory) return

    if (maximumAmount) {
      ToastManager.success(
        `${centsToDollars(maximumAmount)} applied. ${centsToDollars(balanceDueInCents)} Balance due remains.`,
        { autoClose: true },
      )
    }

    // we do not want to interfere with the vanilla split flow.
    // If we came from a split flow then we should not interfere.
    if (currentPaymentFlow !== CFD_POS_PAYMENT_FLOWS.SPLIT_PAY && maximumAmount) {
      yield call(directTo, 'push', {
        pathname: '/tender-selection',
        state: {
          tenderAmountInCents: balanceDueInCents,
          previousPaymentType: PAYMENT_TYPES.FIXED_CUSTOM_TENDER,
          fromSplit: true,
        },
      })
      return
    }

    yield put(setRouteAction(`/receipt/split-tender/${paymentId}`))
  }
}

export function* syncAndSaveOrderInProgress(push, printAuth = false) {
  const isKiosk = yield select((state) => getIsKiosk(state))
  const { menuUuid, revenueCenterUuid, revenueName } = yield menuAndRvcUuids(isKiosk)
  const cfdMode = yield select((state) => getDeviceMode(state))
  const isNetworkAvailable = getNetworkAvailableValue()

  const order = yield select((state) => getOrderInProgress(state))
  const currentPaymentFlow = yield select((state) => getCurrentPaymentFlow(state))
  const isRichCheckout = order?.isRichCheckout || false

  const isBackBar = yield select((state) => getBackbarMode(state))
  const employeeId = yield verifyCurrentAttendant(isKiosk)

  const taxExempt = yield select(getIsOrderTaxExempt)
  const taxExemptData = yield select(getTaxExemptData)
  const taxExemptReason = taxExemptData?.reason || ''
  const taxExemptApproverUuid = yield select(getTaxExemptApproverUuid)

  if (employeeId === undefined) return

  const payments = map(order?.payments, (payment) => {
    const tender = {
      paymentId: payment.paymentId,
      paymentType: payment.paymentType,
      amountInCents: payment.amountInCents,
      shortDescription: payment.shortDescription,
      token: payment.token,
      tip: payment.tip,
      signature: payment.signature,
    }
    if (payment.userAttributes) {
      tender.userAttributes = payment.userAttributes
      tender.userName = payment.userName
    }

    return tender
  })

  const submittedAt = new Date()
  let promotions = yield select(getSelectedPromotions)
  if (isEmpty(promotions) || !order.hasRemoteTotal) {
    promotions = undefined
  }

  // Perhaps this is another attempt to trigger the creation of an order already in our DB.
  const existingOrder = yield select(getOrder, order.uuid)
  // If createOrderParams already exists, maintain the integrity of the order number from the
  // database.
  const orderNumber = getCreateOrderParams(existingOrder)?.orderNumber ?? order.orderNumber

  let userNotes = order?.userNotes
  let orderNotes = yield select((state) => getOrderNotes(state))

  if (!orderNotes) {
    orderNotes = order?.orderNotes
  }

  if (!userNotes) {
    userNotes = yield select(getCartNotes)
  }

  if (orderNotes) {
    userNotes = userNotes ? `${userNotes?.split('\nNote:')[0]}\n${orderNotes}` : `\n${orderNotes}`
  }

  let newOrderState = INTERNAL_ORDER_STATES.CLOSED
  let orderParamsState = STADIUM_ORDER_STATES.COMPLETED

  const removeUuidFromOfflineCardSync = !isOfflineApproval(order)
  const addUuidToSyncArray = !order?.isRichCheckout

  if (order?.isRichCheckout) {
    newOrderState = undefined
  }

  // [T35327] Should not update order states for Kiosk
  if (isKiosk) {
    newOrderState = getCreateOrderParams(order)?.state
    orderParamsState = getCreateOrderParams(order)?.state
  }

  const isCashPayment = order?.payments?.[0]?.paymentType === PAYMENT_TYPES.CASH
  // BackBar does not support split and non-cash
  // stays "tabbed" till finalizing
  // since tabs are initialized as 'tabbed' before the time of transaction, we change to tabbed_offline here if the order was approved offline
  if (isBackBar && !isCashPayment) {
    newOrderState = getCreateOrderParams(order)?.state
    if (order?.isApprovedOffline) {
      orderParamsState = STADIUM_ORDER_STATES.TABBED_OFFLINE
    } else {
      orderParamsState = getCreateOrderParams(order)?.state
    }
  }

  const isScannedTender = orderIsScannedTender(order)
  const orderHasOfflineCardTransactions = hasOfflineCardTransactions(order)

  if ((isScannedTender || order.isMultiPayment) && orderHasOfflineCardTransactions && !order.isTab) {
    newOrderState = STADIUM_ORDER_STATES.APPROVED_OFFLINE
    orderParamsState = STADIUM_ORDER_STATES.APPROVED_OFFLINE
  }

  const createOrderParams = {
    ...makeCreateOrderParams({
      amountInCents: order.amountInCents,
      tipAmountInCents: order.tipAmountInCents,
      charityAmountInCents: order.charityAmountInCents,
      discountAmountInCents: order.discountAmountInCents,
      employeeId,
      itemModels: order.itemModels,
      menuUuid,
      // If createOrderParams already exists, maintain the integrity of the order number from the
      // database.
      orderNumber: getCreateOrderParams(existingOrder)?.orderNumber ?? order.orderNumber,
      submittedAt,
      uuid: order.uuid,
      affiliations: order?.affiliations,
      promotions,
      userNotes,
      orderState: newOrderState,
      originalClientCreatedAt: getCreateOrderParams(order)?.clientCreatedAt,
    }),
    payments: distributeTipAmount(order.tipAmountInCents, payments),
    state: orderParamsState,
    userName: order?.tabName || payments?.[0]?.userName,
  }

  if (!order?.isMultiPayment && payments?.[0]?.userAttributes) {
    if (getIsPreAuthTab(order)) {
      createOrderParams.userAttributes = {
        ...(getCreateOrderParams(order)?.userAttributes ?? order?.userAttributes ?? {}),
      }
    } else {
      createOrderParams.userAttributes = { ...payments?.[0]?.userAttributes }
    }
  }

  const orderData = {
    ...order,
    ...createOrderParams,
    paymentCompleted: true,
    submittedAt,
    revenueName,
    revenueCenterUuid,
    orderNumber,
    state: createOrderParams?.state,
    orderState: newOrderState,
    balanceDueInCents: 0,
    wasCreatedInStadium: order?.isRichCheckout ?? order?.wasCreatedInStadium ?? false,
    taxExempt: order?.taxExempt ?? taxExempt ?? false,
    taxExemptReason: order?.taxExemptReason ?? taxExemptReason ?? '',
    taxExemptApproverUuid: order?.taxExemptApproverUuid ?? taxExemptApproverUuid ?? '',
    cashRounded: order?.cashRounded ?? false,
  }

  if (order?.payments?.length === 1) {
    orderData.displayName = order?.payments?.[0]?.shortDescription
  }

  // if a tabbed order is approved offline, needs to be saved as approved offline order
  if (order?.isApprovedOffline) {
    yield put(saveOfflineOrder(ensureRelatedInvoiceNumbers(orderData)))
  } else {
    yield put(saveOrder(ensureRelatedInvoiceNumbers(orderData), addUuidToSyncArray, removeUuidFromOfflineCardSync))
  }

  yield put(clearRemoteOrderTotal())
  yield put(clearCart())
  yield put(clearPromotionsOnOrder())

  if (!order?.isRichCheckout) {
    yield put(syncOrderInitiated(order?.uuid))
    const shouldRedirect = getIsPreAuthTab(order) ? currentPaymentFlow !== CFD_POS_PAYMENT_FLOWS.GIFT_CARD : true
    yield call(syncOrder, { id: order?.uuid, redirect: shouldRedirect, kioskDirectTo: push })
  }

  const QRpayError = yield select(getQRPayAuthError)

  if (QRpayError && order.payments?.[0].paymentType === 'wallet_nonce') return

  if (cfdMode !== MODES.POS && !isKiosk) {
    yield put(clearOrderInProgress())
  }

  // print slip for backbar when offline
  if (isBackBar && !isNetworkAvailable) {
    // we may need to print after sync
    if (!isCashPayment) {
      yield put(
        printOrder({
          orderUuid: order?.uuid,
          printType: PRINT_TYPES.RECEIPT_AUTH,
        }),
      )
    }

    if (isCashPayment) {
      yield put(setRouteAction(`/receipt/${order?.uuid}`))
      return
    }

    yield put(setRouteAction('/orders'))
    return
  }

  // if tabbed order has not been created in stadium, in case device is offline,
  // redirect to receipt to show that the tab has been completed
  if (isTabbed(order) && !isNetworkAvailable && (!isRichCheckout || cfdMode !== MODES.POS)) {
    yield put(setRouteAction(`/receipt/${order?.uuid}`))
  }

  const isFixedCustomTenderPayment = order?.payments?.[0]?.userAttributes?.isFixedCustomTender
  if (!isNetworkAvailable && isFixedCustomTenderPayment) {
    yield put(setRouteAction(`/receipt/${order?.uuid}`))
  }
}

// removes payment from an order order
export function* removePaymentSaga(params = {}) {
  const paymentIdx = params?.paymentIndex
  const silentFail = params?.silentFail
  const order = { ...params?.order }
  const payment = order?.neededToBeVoidedAuthPayment?.[paymentIdx] ?? order?.payments?.[paymentIdx]

  // should not remove payment after order is set to completed
  if (order?.state === STADIUM_ORDER_STATES.COMPLETED) return
  if (order?.state === STADIUM_ORDER_STATES.COMPLETION_PENDING) return

  try {
    // offline approvals may not be present in LTM and cannot use removePayment mutation
    if (isOfflineApproval(order) && order?.wasCreatedInStadium) {
      order.payments = order.payments.filter((_, idx) => idx !== paymentIdx)

      const updateParams = ensureRelatedInvoiceNumbers(order)
      const result = yield call(StadiumRemote.updatePosOrder, order.uuid, updateParams)
      if (result.data?.state !== STADIUM_ORDER_STATES.AUTHORIZATION_FAILED) {
        if (isCreditType(payment?.paymentType)) {
          order.cardReaderData = null
          order.paymentAuthorizedAt = null
          order.userAttributes = null
        }

        yield put(updateOrderInProgress(order))
        yield put(saveOrder(ensureRelatedInvoiceNumbers(order)))
        return ''
      }

      return result.data.uuid
    }

    const payload = {
      orderId: order?.uuid,
      paymentId: payment?.paymentId,
    }

    const result = yield call(MutationApi.removePayment, payload)
    const curMutation = result?.data?.orderMutations?.[0] ?? { applied: false }
    const applied = curMutation.applied

    if (applied) {
      const updatedOrder = {
        ...order,
        payments: order.payments.filter((_, idx) => idx !== paymentIdx),
      }
      if (isCreditType(payment?.paymentType)) {
        updatedOrder.cardReaderData = null
        updatedOrder.paymentAuthorizedAt = null
        updatedOrder.userAttributes = null
      }

      yield put(updateOrderInProgress(updatedOrder))
      yield put(saveOrder(ensureRelatedInvoiceNumbers(updatedOrder)))
      return curMutation.uuid
    }

    if (!silentFail) {
      const failedOrder = {
        ...order,
        state: STADIUM_ORDER_STATES.AUTHORIZATION_FAILED,
      }
      ToastManager.error(APPLICATION_STRINGS.VOID_PAYMENT_FAILED, { autoClose: false })
      createDataDogLog('error', curMutation.application_message, { orderUuid: order?.uuid })
      yield put(syncOrderFailed({ message: 'Remove Payment Mutation Not Applied' }, failedOrder))
      yield put(updateOrderFailed(order.uuid, failedOrder, null, true))
      return
    }

    return curMutation.uuid
  } catch (error) {
    console.error('Error in removePaymentSaga:', error)
  } finally {
    if (yield cancelled()) {
      createDataDogLog('error', 'Remove Payment Saga Canceled', { orderUuid: order?.uuid })
    }
  }
}

// This method for voiding payments might be temporary until platform adjustments have been made to improve
// the closeTab mutation to accept multiple payments, allocates tip amounts, and deducts VC appropriately.
export function* addNewPaymentsSaga(params = {}) {
  const orderUuid = params?.payload?.uuid
  const order = yield select((state) => getOrder(state, orderUuid))
  const employeeId = getCreateOrderParams(order)?.employeeId
  const userUuid = yield select(getUserUuidFromOrderInProgress)

  /**
   * isRefundReceiptsEnabled is as a feature flag for refund receipts
   * keep in sync with useGetEnvVars hook
   */
  const androidSDKVersion = yield select(getAndroidSDKVersion)
  const isRefundReceiptsEnabled = yield call(refundReceiptsEnabled, androidSDKVersion)

  // if order is not found
  if (!order?.uuid) {
    ToastManager.error(APPLICATION_STRINGS.ORDER_NOT_FOUND)
    return
  }

  if (!order.wasCreatedInStadium) {
    try {
      const createParams = ensureRelatedInvoiceNumbers({
        ...getCreateOrderParams(order),
        payments: order?.voidedCardReaderPayment,
        employeeId,
        userUuid: order?.userUuid ?? userUuid,
      })

      yield call(StadiumRemote.createPosOrder, createParams, false)
      yield put(saveOrder(ensureRelatedInvoiceNumbers({ ...order, wasCreatedInStadium: true })))
    } catch (error) {
      console.error('Error in addNewPaymentsSaga:', error)
      return
    }
  }

  let newOrderData = { ...order }
  try {
    const payload = {
      orderId: orderUuid,
      payment: getCreateOrderParams(order)?.payments?.[0] ?? order?.payments[0],
      cashRounded: order?.cashRounded ?? false,
    }

    const result = yield call(MutationApi.addPayment, payload)
    const applied = result?.data?.orderMutations?.[0]?.applied
    if (!applied) {
      ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
      yield call(directTo, 'push', `/orders`)
      return
    }

    // call order details to retrieve recently voided payment (will be now be for 0 amount in cents)
    const resultOrderDetails = yield call(StadiumRemote.getOrderDetails, orderUuid, isRefundReceiptsEnabled)

    // createOrderParams with undefined payments array
    if (!getCreateOrderParams(newOrderData)?.payments) {
      getCreateOrderParams(newOrderData).payments = []
    }

    getCreateOrderParams(newOrderData).payments = [
      resultOrderDetails?.data?.paymentInfo?.[0],
      ...getCreateOrderParams(order).payments,
    ]
    newOrderData.neededToBeVoidedAuthPayment = undefined
  } catch {
    ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
    yield call(directTo, 'push', `/orders`)
    return
  }

  yield put(saveOrder(ensureRelatedInvoiceNumbers(newOrderData)))
  if (!order?.isRichCheckout) {
    yield put(
      syncOrderRequested({ orderUuid: orderUuid, redirect: true, kioskDirectTo: (location) => call(directTo, 'push', location) }),
    )
  }
}

const getAuthToSync = (payment) =>
  isCreditType(payment?.paymentType) && payment.userAttributes?.token && !payment.userAttributes?.synced

const getCurAuthPayment = (order, payment) => {
  // use provided payment first
  if (payment) return payment

  // search for payment needing sync
  const creditPayments = order.payments?.filter?.(getAuthToSync)

  if (!creditPayments.length) return

  // if multiple, find one with amount
  if (creditPayments.length > 1) {
    return creditPayments.find((payment) => payment.amountInCents > 0)
  }
  return creditPayments[0]
}

/**
 * Updated Tab Payments with Tokens with order mutations
 *
 * @param {Object} order
 * @param {Object} payment
 * @returns {Boolean}
 */
export function* applyAuthTokenWithMutation(order, payment = null) {
  const authPayment = getCurAuthPayment(order, payment)
  if (!authPayment) return false

  const description = authPayment.userAttributes?.maskedCardNumber ?? authPayment.shortDescription

  const token = authPayment.userAttributes?.token
  if (token) {
    const payload = {
      orderId: order.uuid,
      paymentUuid: authPayment.paymentId,
      token,
      reason: `Appending token to payment *${description}`,
      cashRounded: order?.cashRounded ?? false,
    }

    // when executing an update for reopened orders, charity amount needs to be included
    if (order.reopened || order.wasReopened) {
      payload.charityAmountInCents = order.charityAmountInCents || 0
    }

    const result = yield call(MutationApi.updatePayment, payload)

    // mark as synced to avoid reprocessing
    order.payments = order.payments.map((payment) => {
      if (payment.paymentId !== authPayment.paymentId) return payment
      return {
        ...payment,
        userAttributes: {
          ...authPayment.userAttributes,
          isOfflineApproval: false,
          token,
          synced: true,
        },
      }
    })

    // Accumulate invoice numbers after payment update
    const accumulated = ensureRelatedInvoiceNumbers(order)
    if (accumulated.userAttributes?.relatedInvoiceNumbers) {
      order.userAttributes = order.userAttributes || {}
      order.userAttributes.relatedInvoiceNumbers = accumulated.userAttributes.relatedInvoiceNumbers
    }

    const applied = result?.data?.orderMutations?.[0]?.applied
    if (!applied) {
      throw new Error('Update Payment Mutation Not Applied')
    }
  }

  const nextPayment = order.payments.find(getAuthToSync)
  if (nextPayment) {
    return yield call(applyAuthTokenWithMutation, order, nextPayment)
  }

  // tab is still open, mark it as tabbed online in Stadium
  if (isTabbed(order) && !order.payments.some((payment) => payment.userAttributes?.isOfflineApproval)) {
    yield call(MutationApi.stateChange, {
      orderUuid: order.uuid,
      newState: STADIUM_ORDER_STATES.TABBED,
      reason: 'Offline tab was synced successfully',
    })
  }

  return true
}

export function* updateSavedPaymentSaga(params = {}) {
  const tipAmountInCents = parseInt(params?.payload?.tipAmountInCents ?? 0)
  const charityAmountInCents = parseInt(params?.payload?.charityAmountInCents ?? 0)
  const signature = params?.payload?.signature
  const isBackBar = params?.payload?.isBackBar ?? false
  const order = yield select((state) => getOrderInProgress(state))
  const amountInCents = (order?.amountInCents ?? 0) + tipAmountInCents + charityAmountInCents
  const tenderAmountInCents = params?.payload?.tenderAmountInCents
    ? (params?.payload?.tenderAmountInCents ?? 0) + tipAmountInCents + charityAmountInCents
    : amountInCents
  const orderUuid = order?.uuid
  const isNetworkAvailable = getNetworkAvailableValue()

  /**
   * isRefundReceiptsEnabled is as a feature flag for refund receipts
   * keep in sync with useGetEnvVars hook
   */
  const androidSDKVersion = yield select(getAndroidSDKVersion)
  const isRefundReceiptsEnabled = yield call(refundReceiptsEnabled, androidSDKVersion)
  const payment = {
    ...order?.payments?.[0],
    amountInCents,
    tip: tipAmountInCents,
    signature,
  }
  const payments = distributeTipAmount(tipAmountInCents, order.payments || [payment], true)
  if (isNetworkAvailable && order?.wasCreatedInStadium) {
    if (!isOfflineApproval(order) || isBackBar) {
      try {
        // why are we using paymentInfo instead of payments?
        const curPayments = isBackBar ? order?.payments : order?.paymentInfo
        const curPayment = (curPayments || [])?.find((p) => p.amountInCents > 0)
        // find the first active payment by amount
        let paymentUuid = isBackBar ? curPayment?.paymentId : curPayment?.uuid
        if (!paymentUuid) {
          const resultOrderDetails = yield call(StadiumRemote.getOrderDetails, orderUuid, isRefundReceiptsEnabled)
          paymentUuid = resultOrderDetails?.data?.paymentInfo?.[0]?.uuid
        }

        const payload = {
          orderId: orderUuid,
          paymentUuid,
          amountInCents: tenderAmountInCents,
          tip: tipAmountInCents,
          charityAmountInCents,
          signature,
          cashRounded: order?.cashRounded ?? false,
        }

        let result = null
        // for reopend tab don't have paymentInfo orders, but have local payment, add, not update payment
        if (!paymentUuid && order?.reopened && order?.payments?.[0]?.paymentId) {
          const { paymentId, ...curPayment } = order?.payments[0]
          result = yield call(MutationApi.addPayment, {
            orderId: orderUuid,
            payment: curPayment,
            cashRounded: order?.cashRounded ?? false,
          })
        } else {
          result = yield call(MutationApi.updatePayment, payload)
        }

        const applied = result?.data?.orderMutations?.[0]?.applied

        if (!applied) {
          throw new Error('Update Payment Mutation Not Applied')
        }

        // update order with new payment and tip
        if (payments.length === 1) {
          payments[0].tip = tipAmountInCents
          payments[0].signature = signature
          payments[0].amountInCents = tenderAmountInCents
        }
      } catch {
        ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
        yield put(setRouteAction('/orders'))
        return
      }
    } else {
      // Case for updating tip via offline only mode where transaction is not yet in LTM
      const updateOrderParams = ensureRelatedInvoiceNumbers({
        ...getCreateOrderParams(order),
        amountInCents,
        payments,
        charityAmountInCents,
        tipAmountInCents,
        receiptSignature: signature,
      })
      try {
        yield call(StadiumRemote.updatePosOrder, orderUuid, updateOrderParams, false)
      } catch (err) {
        ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
        yield put(setRouteAction('/orders'))
        return
      }
    }
  }

  const newOrderData = {
    ...order,
    balanceDueInCents: 0,
    tipAmountInCents,
    charityAmountInCents,
    amountInCents,
    signature,
    payments,
    state: STADIUM_ORDER_STATES.COMPLETED,
  }

  if (isBackBar) {
    // avoid calling syncOrder if the device is offline
    if (!isNetworkAvailable) {
      yield put(saveOrder(ensureRelatedInvoiceNumbers({ ...newOrderData, needsSync: true })))
      yield put(clearCart())
      yield put(clearOrderInProgress())
      yield put(setRouteAction('/orders'))
      ToastManager.success(APPLICATION_STRINGS.CLOSE_TAB_SUCCEEDED)
      return
    }

    yield put(saveOrder(ensureRelatedInvoiceNumbers(newOrderData), false))
    yield put(syncOrderRequested({ orderUuid, redirect: true }))
    return
  }

  yield put(updateOrderInProgress(newOrderData))
  yield call(syncAndSaveOrderInProgress)
}

// TODO: refactor into separate function and one consistent try-catc
// closeTabOrderSaga currently disabled, possibly to deprecate in the near future TODO (JEFF)
export function* closeTabOrderSaga(params = {}) {
  const order = cloneDeep(params?.payload?.order)
  const redirect = params?.payload.redirect ?? false
  const supressToasts = params?.payload.supressToasts ?? false
  const orderUuid = order?.uuid
  const cfdMode = yield select((state) => getDeviceMode(state))
  const employeeId = getCreateOrderParams(order)?.employeeId
  const isBackBar = yield select((state) => getBackbarMode(state))
  const isCashPayment = order?.payments?.length === 1 && order.payments?.[0]?.paymentType === PAYMENT_TYPES.CASH
  const successRedirectPath = isBackBar && !isCashPayment ? '/orders' : `/receipt/${orderUuid}`
  const userUuid = yield select(getUserUuidFromOrderInProgress)

  const authPayment = order?.neededToBeVoidedAuthPayment?.[0] ?? getCreateOrderParams(order)?.payments?.[0] ?? {}
  if (!order.wasCreatedInStadium) {
    const state = isOfflineApproval(order) ? STADIUM_ORDER_STATES.TABBED_OFFLINE : STADIUM_ORDER_STATES.TABBED

    try {
      // some devices may not throw an error when offline in a timely man
      if (!getNetworkAvailableValue()) {
        throw new Error('Network Error')
      }

      const createParams = ensureRelatedInvoiceNumbers({
        ...getCreateOrderParams(order),
        payments: [
          {
            ...authPayment,
            userAttributes: { ...authPayment.userAttributes, authId: authPayment.paymentId },
          },
        ],
        employeeId,
        state,
        amountInCents: authPayment?.amountInCents,
        userUuid: order?.userUuid ?? userUuid,
      })

      yield call(StadiumRemote.createPosOrder, createParams, false)

      // map the resulting payment uuids back to local state
      const result = yield call(StadiumRemote.getOrderDetails, orderUuid)
      const remotePayments = result?.data?.paymentInfo ?? []

      // helper to map updated payment uuid from response
      const updatedPayments = (order.payments || []).map((payment) => {
        const curPayment = mapUpdatedPaymentUuidFromResponse(remotePayments, payment)
        if (order.payments.length === 1 && !order.neededToBeVoidedAuthPayment) {
          return {
            ...curPayment,
            userAttributes: {
              ...payment.userAttributes,
              isOriginalAuth: true,
            },
          }
        }
        return curPayment
      })
      const updatedAuths = (order.neededToBeVoidedAuthPayment || []).map((payment) =>
        mapUpdatedPaymentUuidFromResponse(remotePayments, payment),
      )

      order.payments = updatedPayments
      order.neededToBeVoidedAuthPayment = updatedAuths.length ? updatedAuths : null
      yield put(saveOrder(ensureRelatedInvoiceNumbers({ ...order, wasCreatedInStadium: true }), false))
    } catch (err) {
      // on error, tip distribution must take place per payment
      const orderUpdate = {
        ...order,
        payments: distributeTipAmount(order.tipAmountInCents, order.payments),
      }
      yield put(syncOrderFailed(err, orderUpdate))
      yield put(clearOrderInProgress())

      // If platform order creation fails here, it means that a non-synced pre auth tab was attempted to be
      // closed offline, which should appear to be successful]
      if (!supressToasts) {
        ToastManager.success(APPLICATION_STRINGS.CLOSE_TAB_SUCCEEDED)
      }
      if (redirect) {
        yield put(setRouteAction(successRedirectPath))
      }
      if (cfdMode === MODES.POS) {
        yield put(resetCFD())
      }
      return
    }
  }

  /**
   * Should call addPayment mutation when tabbed_offline
   *
   * 'tabbed' - is online or started without payment
   * 'tabbed_offline' - started with a payment
   */
  const hasNewPayments =
    order.state === STADIUM_ORDER_STATES.TABBED_OFFLINE &&
    order?.originalTransactionId &&
    order.originalTransactionId !== order?.cardReaderData?.uuid

  const isReopenedWithNewPayments =
    (order.reopened || order.wasReopened) &&
    order.payments?.length > 0 &&
    order.payments.some((payment) => {
      // Check if this payment exists in paymentInfo
      const existsInStadium = order.paymentInfo?.some((stadiumPayment) => stadiumPayment.uuid === payment.paymentId)
      return !existsInStadium
    })

  const isAddPaymentLater = !order.paymentInfo?.length && order.payments.length > 0
  const orderPayments = order?.payments || getCreateOrderParams(order)?.payments
  // keep track of unused card payments
  const usedCardPayments = order.paymentInfo?.filter((p) => isCreditType(p.paymentType) && p.amountInCents > 0)
  const unusedCardPaymentSet = new Set(order.reopened ? usedCardPayments.map((p) => p.uuid) : [])
  orderPayments.forEach((payment) => {
    if (unusedCardPaymentSet.has(payment.paymentId)) {
      unusedCardPaymentSet.delete(payment.paymentId ?? payment.uuid)
    }
  })
  // Exception for BackBar offline auth that is voided during Print Slip
  const hasPendingVoidAuths = order?.neededToBeVoidedAuthPayment?.some((payment) => !payment.isVoided)

  // TODO: refactor with explicit flags
  // ONLINE transactions - neededToBeVoidedAuthPayment - should removePayment and addPayment
  // OFFLINE transactions - hasNewPayments - should addPayment, but not remove
  let replacePayments = false
  if (
    isReopenedWithNewPayments ||
    hasPendingVoidAuths ||
    hasNewPayments ||
    isAddPaymentLater ||
    isCashPayment ||
    unusedCardPaymentSet.size > 0
  ) {
    try {
      // what will happen here when we are dealing with a previous auth failed?
      replacePayments = true
      const paymentsWithTips = distributeTipAmount(order.tipAmountInCents, orderPayments)
      const addPayments = []
      const updatePayments = []

      // check if closing with any preauths and update them
      paymentsWithTips.forEach((payment) => {
        if (payment.userAttributes?.isOriginalAuth && payment.amountInCents > 0) {
          replacePayments = false
          updatePayments.push({
            ...payment,
            paymentId: payment.paymentId ?? payment.userAttributes.paymentId,
          })
          return
        }

        addPayments.push({ ...payment, userAttributes: { ...payment.userAttributes, isBackBar } })
      })

      // Accumulate invoice numbers before mutations
      const accumulatedOrder = ensureRelatedInvoiceNumbers(order)
      if (accumulatedOrder.userAttributes?.relatedInvoiceNumbers) {
        order.userAttributes = order.userAttributes || {}
        order.userAttributes.relatedInvoiceNumbers = accumulatedOrder.userAttributes.relatedInvoiceNumbers
      }

      // if using preauths, update payments
      for (const payment of updatePayments) {
        const description = payment.userAttributes?.maskedCardNumber ?? payment.shortDescription
        const payload = {
          orderId: orderUuid,
          paymentUuid: payment.paymentId,
          amountInCents: payment.amountInCents,
          charityAmountInCents: order?.charityAmountInCents,
          tip: payment.tipAmountInCents ?? payment.tip ?? 0,
          reason: `Updating original auth amount of *${description}`,
          cashRounded: order?.cashRounded ?? false,
        }
        const result = yield call(MutationApi.updatePayment, payload)
        const applied = result?.data?.orderMutations?.[0]?.applied
        if (!applied) {
          ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
          yield put(syncOrderFailed({ message: 'Update Payment Mutation Not Applied' }, order))
          if (redirect) {
            yield put(setRouteAction(`/concession-order`))
          }
          if (cfdMode === MODES.POS) {
            yield put(resetCFD())
          }
          yield put(clearOrderInProgress())
          return
        }
      }

      if (addPayments.length) {
        const payload = {
          orderId: order?.uuid,
          payments: addPayments,
          replacePayments,
          charityAmountInCents: order?.charityAmountInCents,
          reason: `Adding payment(s) *${addPayments.map((p) => p.shortDescription)?.join(', ')}`,
          cashRounded: order?.cashRounded ?? false,
        }

        const result = yield call(MutationApi.addPayment, payload)
        const applied = result?.data?.orderMutations?.[0]?.applied

        if (!applied) {
          ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
          yield put(syncOrderFailed({ message: 'Add Payment Mutation Not Applied' }, order))
          if (redirect) {
            yield put(setRouteAction(`/concession-order`))
          }
          yield put(clearOrderInProgress())
          if (cfdMode === MODES.POS) {
            yield put(resetCFD())
          }
          return
        }

        // so long as none of the to void auths are offline, okay to clear
        if (!order.neededToBeVoidedAuthPayment?.some?.((payment) => payment.userAttributes?.isOfflineApproval)) {
          order.neededToBeVoidedAuthPayment = null
        }
      }
    } catch (err) {
      ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
      yield put(syncOrderFailed(err, order))
      yield put(clearOrderInProgress())
      if (cfdMode === MODES.POS) {
        yield put(resetCFD())
      }
      if (redirect) {
        yield put(setRouteAction(`/concession-order`))
      }
      return
    }
  }

  // void unused card payments for reopened orders
  if (order.reopened && unusedCardPaymentSet.size > 0 && !replacePayments) {
    for (const paymentId of unusedCardPaymentSet) {
      // Logic to void unused card payments
      try {
        const payload = { orderId: order?.uuid, paymentId }

        const result = yield call(MutationApi.removePayment, payload)
        const applied = result?.data?.orderMutations?.[0]?.applied

        if (!applied && !supressToasts) {
          ToastManager.error(APPLICATION_STRINGS.VOID_PAYMENT_FAILED, { autoClose: false })
        }
      } catch (err) {
        if (!supressToasts) {
          ToastManager.error(APPLICATION_STRINGS.VOID_PAYMENT_FAILED, { autoClose: false })
        }
      }
    }
  }

  let closePayload = {
    orderId: orderUuid,
    receiptSignature: order?.signature ?? order?.receiptSignature,
    charityAmountInCents: order?.charityAmountInCents,
    tipAmountInCents: order?.tipAmountInCents,
    userName: getCreateOrderParams(order)?.userName,
    taxExempt: order?.taxExempt ?? false,
    cashRounded: order?.cashRounded ?? false,
  }

  try {
    const result = yield call(MutationApi.closeTabOrder, closePayload)
    const applied = result?.data?.orderMutations?.[0]?.applied

    if (applied) {
      const updatedOrder = { ...order, isClosedTab: true }
      const removeFromCardSyncArray =
        order.originalTransactionId &&
        isScannedTenderNonCC(order.payments) &&
        !order.neededToBeVoidedAuthPayment?.some((payment) => payment.userAttributes?.isOfflineApproval)
      yield put(saveOrder(updatedOrder, false, removeFromCardSyncArray))
      yield put(syncOrderSucceeded(result, updatedOrder))
      if (!supressToasts) {
        ToastManager.success(APPLICATION_STRINGS.CLOSE_TAB_SUCCEEDED)
      }
      yield put(orderDetailsRequested(orderUuid))
      if (redirect) {
        yield put(setRouteAction(successRedirectPath))
      }
    } else {
      ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
      yield put(syncOrderFailed({ message: 'Close Tab Mutation Not Applied' }, order))
      if (cfdMode === MODES.POS) {
        yield put(resetCFD())
      }
      if (redirect) {
        yield put(setRouteAction(`/concession-order`))
      }
    }
  } catch (err) {
    ToastManager.error(APPLICATION_STRINGS.CLOSE_TAB_FAILED, { autoClose: false })
    yield put(syncOrderFailed(err, order))
    if (cfdMode === MODES.POS) {
      yield put(resetCFD())
    }
    if (redirect) {
      yield put(setRouteAction(`/concession-order`))
    }
  }

  if (cfdMode !== MODES.POS) {
    yield put(clearOrderInProgress())
  }
}

/**
 * Cancels order in Stadium by ID
 * Primarily used for cancelling orders that are already created in Stadium
 * (e.g. user started a card transaction, backed out, emptied cart then started a new order)
 *
 * @param {String} uuid
 * @param {?String} reason
 */
export function* cancelOrderSaga(params = {}) {
  const uuid = params?.payload?.uuid
  const reason = params?.payload?.reason ?? 'Order Cancelled from POS'
  const order = yield select((state) => getOrder(state, uuid))

  const updatedOrder = { ...order, state: STADIUM_ORDER_STATES.CANCELLED }

  if (!order.wasCreatedInStadium) {
    yield put(saveOrder(ensureRelatedInvoiceNumbers(updatedOrder), false))
    return
  }

  try {
    const result = yield call(MutationApi.cancelOrder, uuid, reason)
    const applied = result?.data?.orderMutations?.[0]?.applied

    if (!applied) {
      createDataDogLog('error', 'Unable to cancel order', { orderUuid: uuid, result })
      yield put(syncOrderFailed(result, updatedOrder))
      return
    }

    yield put(saveOrder(updatedOrder, false))
    yield put(syncOrderSucceeded(result, updatedOrder))
    yield put(orderDetailsRequested(uuid))
    yield put(setCurrentOrderId(null))
  } catch (err) {
    createDataDogLog('error', 'Unable to cancel order', { orderUuid: uuid, err })
    yield put(syncOrderFailed(err, order))
  }
}

export function* closePreAuthedRCOrderSaga(params = {}) {
  const uuid = params?.payload?.uuid
  const cfdMode = yield select(getDeviceMode)
  const networkAvailable = getNetworkAvailableValue()

  // in case of offline or slow network save locally as a rich checkout order.
  const order = yield select((state) => getOrder(state, uuid))
  let balanceDueInCents = order.balanceDueInCents - order.amountInCents

  if (balanceDueInCents < 0) {
    balanceDueInCents = 0
  }

  const newOrderData = {
    ...order,
    isRichCheckout: true,
    balanceDueInCents,
    payments: [
      {
        paymentType: 'mobile_app',
        amountInCents: order.amountInCents,
        shortDescription: 'App',
      },
    ],
    wasCreatedInStadium: true,
    errorMessage: undefined, // reset error message
  }

  yield put(saveOrder(ensureRelatedInvoiceNumbers(newOrderData), false))

  /**
   * We assume that the auth payment is dropped in the backend when the RC payment
   * is applied. Then we just fetch order details which should update all our order local state.
   */
  if (networkAvailable) {
    yield put(orderDetailsRequested(uuid))
  }
  if (cfdMode !== MODES.POS) {
    yield put(setRouteAction(`/receipt/${uuid}`))
  }

  yield put(clearOrderInProgress())
}

/**
 * Platform Background Sync Saga ("Auto-Sync")
 */
export function* syncNextOrderData() {
  const isSyncing = yield select(getIsSyncing)
  const networkAvailable = yield select(getNetworkAvailable)

  // prevent multiple syncs from running at the same time
  if (isSyncing || !networkAvailable) return

  const orderIds = yield select((state) => getSyncableOfflineLocalIds(state, undefined, true))

  // if there are no orders to sync, exit early
  if (orderIds.length <= 0) return

  createDataDogLog('info', 'Silent platform sync initiated.', { offlineLocalIds: orderIds })
  const nextOrderId = orderIds.slice(0, 1)[0]

  try {
    // Do the delay first otherwise, the sync will catch the local ID update and start pushing the
    // next order before the delay is complete.
    createDataDogLog('info', `Syncing next order to platform: ${nextOrderId}`)
    yield put(syncOrderRequested({ orderUuid: nextOrderId, displayOrderToast: false, offlineOrder: true, fromSyncOrders: true }))
  } catch (error) {
    createDataDogLog('error', `Error platform syncing ${nextOrderId} : ${error}`)
  }
}

export function* watchSyncNextOrderToPlatform() {
  yield takeLeading(SYNC_NEXT_ORDER_TO_PLATFORM, syncNextOrderData)
}

export function* watchSyncReplayAuthOrders() {
  yield takeLeading(SYNC_REPLAY_AUTH_ORDERS_REQUESTED, syncOrdersReplayAuth)
}

export function* watchReplayAuthStatus() {
  const queue = yield actionChannel(REPLAY_AUTH_REQUESTED)

  while (true) {
    const payload = yield take(queue)

    yield put(syncOrderInitiated(payload.order.uuid))
    yield call(getReplayAuthStatus, payload.order)
  }
}

export function* watchStartATab() {
  yield takeEvery(START_A_TAB, startATabSaga)
}

export function* watchCancelOrder() {
  yield takeLatest(CANCEL_ORDER, cancelOrderSaga)
}

export function* watchCloseTabOrder() {
  yield takeEvery(CLOSE_TAB_ORDER, closeTabOrderSaga)
}

export function* watchAddItemsToTab() {
  yield takeEvery(ADD_ITEMS_TO_TAB, addItemsToTab)
}

export function* watchAddItemsToTabOffline() {
  yield takeEvery(ADD_ITEMS_TO_TAB_OFFLINE, addItemsToTabOffline)
}

export function* watchAddDiscountsToTabOrder() {
  yield takeEvery(ADD_DISCOUNTS_TO_TAB_ORDER, addDiscountsToTabOrderSaga)
}

export function* watchDeleteDiscountsFromTabOrder() {
  yield takeEvery(DELETE_DISCOUNTS_FROM_TAB_ORDER, deleteDiscountsFromTabOrderSaga)
}

export function* watchStartOfflineCardOrder() {
  yield takeEvery(START_OFFLINE_CARD_ORDER, startOfflineCardOrder)
}

export function* watchStartOnlineCardOrder() {
  yield takeEvery(START_ONLINE_CARD_ORDER, startOnlineCardOrder)
}

export function* watchSaveRichCheckoutOrder() {
  yield takeEvery(SAVE_RICH_CHECKOUT_ORDER_REQUESTED, _saveRichCheckoutOrder)
}

export function* watchCloseNoOpTender() {
  yield takeEvery(CLOSE_NO_OP_TENDER, closeNoOpTenderSaga)
}

export function* watchSyncOrder() {
  const queue = yield actionChannel(SYNC_ORDER_REQUESTED)

  while (true) {
    const payload = yield take(queue)

    yield put(syncOrderInitiated(payload.id))
    yield call(syncOrder, payload)
  }
}

export function* watchSyncOfflineOrder() {
  const queue = yield actionChannel(SYNC_OFFLINE_ORDER_REQUESTED)

  while (true) {
    const payload = yield take(queue)

    yield put(syncOrderInitiated(payload.id))
    yield call(syncOfflineOrder, payload)
  }
}

export function* watchSyncAndSaveOrderInProgress() {
  yield takeLeading(SYNC_AND_SAVE_ORDER_IN_PROGRESS, syncAndSaveOrderInProgress)
}

export function* watchUpdateCardReaderDataSaga() {
  yield takeEvery(UPDATE_CARD_READER_DATA, updateCardReaderDataSaga)
}

export function* watchSyncOrders() {
  yield takeLeading(SYNC_ORDERS_REQUESTED, syncOrders)
}

export function* watchAddPaymentToOrderInProgress() {
  yield takeLeading(ADD_PAYMENT_TO_ORDER_IN_PROGRESS, addPaymentToOrderInProgressSaga)
}

export function* watchAddNewPayments() {
  yield takeLeading(ADD_NEW_PAYMENTS, addNewPaymentsSaga)
}

function* removePaymentCancellableSaga(params) {
  yield race([call(removePaymentSaga, params), take(CANCEL_REMOVE_PAYMENT)])
}

export function* watchRemovePayment() {
  yield takeLatest(REMOVE_PAYMENT, removePaymentCancellableSaga)
}

export function* watchUpdateSavedPayment() {
  yield takeLeading(UPDATE_SAVED_PAYMENT, updateSavedPaymentSaga)
}

export function* getTabOrders() {
  if (!getNetworkAvailableValue()) {
    yield put(loadTabOrdersFailed(Error('Device is offline')))
    return
  }

  const venueUuid = yield select((state) => get(state, 'config.venueUuid', ''))
  const standMenuUuids = yield select((state) => get(state, 'config.configuration.menuUuids', []))

  const updatedSince = yield select((state) => getUpdatedSince(state))

  let requestPayload = { venueUuid, standMenuUuids, updatedSince }

  try {
    const result = yield call(StadiumRemote.getOrders, requestPayload)
    const { byId: mappedResult, reopenedPaymentsById } = DataMapper.ordersMapper(get(result, 'data', []))

    // only mark updated since if we successfully pulled orders
    yield put(setUpdatedSince())
    yield put(loadTabOrdersSucceeded(mappedResult))

    for (const orderUuid of Object.keys(reopenedPaymentsById)) {
      const payments = reopenedPaymentsById[orderUuid] || []
      // prevent removing local reopened payments if there are no payments in stadium
      if (payments.length === 0) continue
      yield put(setReopenedTabPaymentsAction({ orderUuid, payments }))
    }
  } catch (err) {
    if (isNetworkError(err)) {
      yield put(setNetworkAvailable(false))
    }
    yield put(loadTabOrdersFailed(err))
    ToastManager.error('Orders failed to load', { autoClose: false })
  }
}

export function* watchGetTabOrders() {
  yield takeLeading(TAB_ORDERS_REQUESTED, getTabOrders)
}

export function* getOrderDetails(params = {}) {
  let order = undefined
  /**
   * isRefundReceiptsEnabled is as a feature flag for refund receipts
   * keep in sync with useGetEnvVars hook
   */
  const androidSDKVersion = yield select(getAndroidSDKVersion)
  const isRefundReceiptsEnabled = yield call(refundReceiptsEnabled, androidSDKVersion)
  const useTaxClasses = yield select(getUseTaxClasses)

  try {
    order = yield select(getOrder, params.payload.orderUuid)

    const result = yield call(StadiumRemote.getOrderDetails, params.payload.orderUuid, isRefundReceiptsEnabled)

    const items = yield select((state) => getItemsForCurrentMenu(state))
    const mappedResult = DataMapper.orderDetailsMapper(get(result, 'data', {}), items?.byId ?? {}, useTaxClasses)

    yield put(loadOrderDetailsSucceeded({ order: mappedResult, isRefundReceiptsEnabled }))

    //On reopened orders we need to store the updated CC payments information in VNTenders state
    if (mappedResult.reopened && mappedResult.paymentInfo?.length > 0) {
      const mappedPayments = mappedResult.paymentInfo.map((payment) => mapPayments(payment, order.orderNumber))
      yield put(setReopenedTabPaymentsAction({ orderUuid: params.payload.orderUuid, payments: mappedPayments }))
    }

    if (params.payload.refreshOrderInProgress) {
      yield put(setOrderInProgressWithId(params.payload.orderUuid))
      yield put(stopSpinner())
    }
  } catch (err) {
    if (order?.errorMessage) {
      ToastManager.error(`Order Number ${order?.orderNumber}: ${order.errorMessage}`, { autoClose: false })
    }
    yield put(loadOrderDetailsFailed({ orderUuid: params.payload?.orderUuid }))

    if (params.payload.refreshOrderInProgress) {
      yield put(stopSpinner())
    }
  }
}

export function* watchGetOrderDetails() {
  const queue = yield actionChannel(ORDER_DETAILS_REQUESTED)

  while (true) {
    const payload = yield take(queue)

    yield call(getOrderDetails, payload)
  }
}

export function* watchClosePreAuthedRCOrder() {
  yield takeEvery(CLOSE_PRE_AUTHED_RC_ORDER, closePreAuthedRCOrderSaga)
}
